import { gql } from "@urql/vue";

export const BRAND = `
query SlBrand {
  slBrand {
    id
    name
    countryCode
    country {
      smsFeatureBlocked
      smsOtpBlocked
      currency {
        name
        code
        symbol
      }
      spendingCurrency {
        name
        code
        symbol
        currencySpendDefault {
          googleReviewMinSpend
        }
      }
    }
    role
    token
    name
    slug
    active
    collectionType
    industryId
    loyaltyConversionLock
    recentlyConvertedProgram
    lastLoyaltyProgSwitch
    stpc {
      id
      specification
      active
      modifier
      threshold
      spendRequirement
      spendExpiryYears
    }
    availableCredits
    currentMessageRates {
      whatsappRate
      smsRate
    }
    uniqueMembersInTransient
    daysTillDeletion
    messageInQueue
    userSubscription{
      expiryDate
      phase
      registeredNameId
      downgradeOnExpiry
      subscriptionDaysLeft
    }
    minimumRechargeValue {
      defaultSingleCredit
      defaultAutoCredit
      defaultRechargeThreshold
    }
    brandCategorization {
      jobId
      temporaryCategory
      jobType
      jobStatus
    }
    createdAt
    hasOngoingChanceCampaign
    defaultSmsTemplate {
      broadcastMsg
      automationMsg
      acquisitionMsg
      chanceMsg
      igGiveawayMsg
      membershipTierMsg
      membershipTierWaMsg
      membershipTierVoucherMsg
      membershipBdayVoucherMsg
      verificationMsg
      redemptionMsg
      redemptionReminderMsg
      expiryReminderMsg
      trackedCampaignMsg
      redemptionStampMsg
    }
    messagePackage {
      amount
    }
    totalUnsentMessages
    unmatchedRewards
    urgentConversationCount
    conversationIntegrated
    showConversation
    websiteToken
    brandConfiguration {
      pointsName
      codeGenFormula
      posIntegration
      ecommerceIntegration
      insightSetup
      integrationFreePrompt
      showPointRenameWarning
      needEmailVerification
      whatsappChatAutomationEnabled
      whatsappChatAutomationTriggerPhrase
    }
    shopifyProducts {
      id
      title
    }
    eats365MatchRewardEnabled
    collectionType
    brandInsightConfiguration{
      carouselOrder
      aiccoUsers
    }
    monthlyAdditionalSales
    brandGroup{
      id
      name
      totalBrands
      brands{
        id
        name
        brandPortalSetting {
          logoUrl
        }
      }
    }
    usingInternalWaba
  }
}
`;

export const BRAND_CUSTOMERS = `
query slBrand {
  slBrand {
    id
    totalVisits
    overallUsers
    returnRate
  }
}
`;

export const BRAND_AVAILABLE_CREDITS = `
query SlBrand {
  slBrand {
    id
    name
    availableCredits
    overallUsers
    countryCode
    unsubscribedUsers {
      id
    }
    unsubscribedNumbers
  }
}
`;

export const BRAND_INFO = `
query SlBrand {
  slBrand {
    id
    name
    overallUsers
    countryCode
    unsubscribedUsers {
      id
    }
    unsubscribedNumbers
    testSmsNumber
    brandConfiguration {
      id
      foreignBroadcastEnabled
    }
    emailSetting {
      id
      fullSender
      sender
      senderName
      domainType
      verified
    }
  }
}
`;

export const BRAND_SMS_FREQUENCY = `
query Brand($forBroadcast: Boolean, $channel: String) {
  slBrand {
    id
    groupedCustomerVisits(forBroadcast: $forBroadcast, channel: $channel)
  }
}
`;

export const BRAND_SMS_INACTIVE = `
query Brand($forBroadcast: Boolean, $channel: String) {
  slBrand {
    id
    inactiveVisits(forBroadcast: $forBroadcast, channel: $channel) {
      spec
      label
      value
    }
  }
}
`;

export const BRAND_SMS_LIFETIME = `
query Brand(
  $keyword: String!
  $input: String!
  $forBroadcast: Boolean
) {
  slBrand {
    id
    customersBySpending(
      keyword: $keyword
      input: $input
      forBroadcast: $forBroadcast
    )
  }
}
`;

export const BRAND_POINTS = `
query Brand(
  $keyword: String!
  $input: String!
  $spec: String!
  $forBroadcast: Boolean
) {
  slBrand {
    id
    customersByPoints(
      keyword: $keyword
      input: $input
      spec: $spec
      forBroadcast: $forBroadcast
    )
  }
}
`;

export const BRAND_OUTLETS_CUSTOMERS = `
query Brand(
  $input: String!
  $forBroadcast: Boolean
) {
  slBrand {
    id
    customersByOutlet(input: $input, forBroadcast: $forBroadcast)
  }
}
`;

export const UPDATE_STPC = `
mutation UpdateStpc(
  $threshold: Int!
  $modifier: Int!
  $specification: String!
  $spendRequirement: Int
  $spendExpiryYears: Int
){
  updateStpc(
    threshold: $threshold
    modifier: $modifier
    specification: $specification
    spendRequirement: $spendRequirement
    spendExpiryYears: $spendExpiryYears
  ) {
    result
    errors { message }
  }
}
`;

export const REGISTER_PROMOTION = `
 mutation RegisterPromotion(
  $title: String!,
  $cost: Int!,
  $brandId: String!,
  $specification: Int!,
  $monetaryCost: String!,
  $promotionType: String!
  $discountLimit: Int
  $posIntegration: String
  $ecomIntegration: String
  $shopifyProductId: String
  $toRemind: Boolean
  $rebateCost: Float
  $esbItemCode: String
  $rewardDisplayName: String
  $eats365ProductCode: String
 ) {
  registerPromotion(
    title: $title,
    cost: $cost,
    brandId: $brandId,
    specification: $specification,
    monetaryCost: $monetaryCost,
    promotionType: $promotionType
    discountLimit: $discountLimit
    posIntegration: $posIntegration
    ecomIntegration: $ecomIntegration
    shopifyProductId: $shopifyProductId
    toRemind: $toRemind
    rebateCost: $rebateCost
    esbItemCode: $esbItemCode
    rewardDisplayName: $rewardDisplayName
    eats365ProductCode: $eats365ProductCode
  ) {
    promotion {
      id
      title
      toRemind
    }
    integrationItemCode
    errors {
      message
    }
  }
 }
`;

export const POINT_PROMOTIONS = `
  query Promotions(
    $sort: String,
    $direction: String,
    $filters: PromotionSearch,
  ) {
      brand: slBrand {
      id
      promotions(
        sort: $sort
        direction: $direction
        filters: $filters
      ) {
        id
        title
        rewardDisplayName
        cost
        monetaryCost
        active
        specification
        promotionType
        archived
        imageUrl
        toRemind
        rewardDisplayName
      }
    }
  }
`;

export const DASHBOARD_PROMOTIONS = gql`
  query DashboardPromotions(
    $sort: String
    $direction: String
    $filters: PromotionSearch
  ) {
    brand: slBrand {
      id
      promotions(sort: $sort, direction: $direction, filters: $filters) {
        id
        title
        cost
        active
        promotionType
        monetaryCost
        imageUrl
      }
    }
  }
`;

export const TOGGLE_ACTIVE = `
  mutation ToggleActive($id: ID!, $active: Boolean!) {
    togglePromotionActive(active: $active, id: $id) {
      promotion {
        id
        title
        active
      }

      errors {
        message
      }
    }
  }
`;

export const TOGGLE_ARCHIVE = `
  mutation TogglePromotionArchive($id: ID!, $archived: Boolean!) {
    togglePromotionArchive(archived: $archived, id: $id) {
      result
      errors {
        message
      }
    }
  }
`;

export const EDIT_MONETARY_COST = `
  mutation EditMonetaryCost($promotionId: ID!, $monetaryCost: Float!) {
    editPromotionMonetaryCost(promotionId: $promotionId, monetaryCost: $monetaryCost) {
      result
      errors {
        message
      }
    }
  }
`;

export const EDIT_PROMOTION_TITLE = `
  mutation EditPromotionTitle($promotionId: ID!, $title: String!) {
    editPromotionTitle(promotionId: $promotionId, title: $title) {
      result
      errors {
        message
      }
    }
  }
`;

export const EDIT_PROMOTION_NAME = `
  mutation EditPromotionName(
    $promotionId: ID!
    $title: String!
    $rewardDisplayName: String
  ) {
    editPromotionName(
      promotionId: $promotionId
      title: $title
      rewardDisplayName: $rewardDisplayName
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const POINT_REDEMPTION_HISTORY = ` 
  query BrandRedemptions(
    $filters: RedemptionSearch
    $limit: Int
    $currentPage: Int!
    $sort: String!
    $direction: String!
  ) {
    slBrand {
      id
      overallRedemptions(filters: $filters)
      redemptions(
        filters: $filters
        limit: $limit
        currentPage: $currentPage
        sort: $sort
        direction: $direction
      ) {
        id
        promotion {
          id
          title
          cost
          rewardDisplayName
        }
        outlet {
          id
          name
        }
        customerId
        createdAt
        void
        stampCard {
          stampsCollected
        }
      }
    }
  }
`;

export const POINTS_COLLECTION_HISTORY = ` 
  query BrandCollections(
    $filters: CollectionSearch
    $limit: Int
    $currentPage: Int!
    $sort: String!
    $direction: String!
  ) {
    slBrand {
      id
      overallCollections(
        filters: $filters
      )
      collections(
        filters: $filters
        limit: $limit
        currentPage: $currentPage
        sort: $sort
        direction: $direction
      ) {
        id
        customerId
        createdIso
        updatedIso
        collectedPoints
        collectedStamps
        spending
        outletId
        outletName
        expiryDays
        expired
        edited
        groupRecredit
        groupExpired
      }
    }
  }
`;

export const BROADCAST_MESSAGE_HISTORY = ` 
  query GetBroadcastMessageHistory(
    $filters: BroadcastSearch
    $limit: Int!
    $currentPage: Int!
    $sort: String!
    $direction: String!
    $isEmail: Boolean!
  ) {
    slBrand {
      broadcasts(
        limit: $limit
        currentPage: $currentPage
        sort: $sort
        direction: $direction
        filters: $filters
        isEmail: $isEmail
      ) {
          overallBroadcasts
          records {
            id
            campaignId
            type
            title
            sbsc
            nameholder
            sentDate
            expiryDate
            status
            recipients
            successful
            pending
            insufficient
            apiError
            skipped
            redeemed
            conversions
            roi
            message
            promoId
            promoTitle
            returnees
            returneesPerc
            metadata
            messageType
            emailTemplateSubject
            emailTemplateContent
            emailAnalytics {
              value
              uniq
              count
              event
            }
          }
      }
    }
  }
`;

export const VOID_REDEMPTION = `
mutation VoidRedemption(
  $id: ID!,
) {
  voidRedemption(
    id: $id
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const USER_BRANDS = `
query {
  userBrands {
      brandId
      name
      role
      status
      inviterName
      logoUrl
  }
}
`;

export const USERS = `
query Users{
  users {
      id
      email
      lastSignInAt
      name
      status
      userPermissions {
          name
          read
          modify
          download
      }
      userRole
  }
}
`;

export const USER_BASIC_INFO = `
query Users{
  users {
      email
      name
  }
}
`;

export const SET_ACTIVE_BRAND = `
  mutation SetActiveBrand(
    $brandId: String!
  ) {
    setActiveBrand(
      brandId: $brandId
    ) {
      result
      name
      country
      currency
      active
      errors {
        message
      }
    }
  }
`;

export const CREATE_BRAND_AND_OUTLETS = `
mutation CreateBrandAndOutlets(
  $name: String!,
  $industry: String!,
  $countryCode: String!,
  $outlets: [OutletInput!]!
  $stpcThreshold: Int!
  $stpcModifier: Int!
  $stpcSpecification: String!
  $promotions: [PromotionInput!]!
  $timezone: String!
  $collectionType: String!
  $averageSpend: Int!
  $stampConfig: StampConfigInput
) {
  createBrandAndOutlets(
    name: $name,
    industry: $industry,
    countryCode: $countryCode,
    outlets: $outlets
    stpcThreshold: $stpcThreshold
    stpcModifier: $stpcModifier
    stpcSpecification: $stpcSpecification
    promotions: $promotions
    timezone: $timezone
    collectionType: $collectionType
    averageSpend: $averageSpend
    stampConfig: $stampConfig
  ) {
      result
      brandId
      stampConfigurationId
      outletCredentials {
        name
        id
        password
      }
      errors {
        message
    }
  }
}
`;

export const CREATE_OUTLETS = `
  mutation CreateOutlets($outlets: [OutletInput!]!) {
    createOutlets(outlets: $outlets) {
      outletCredentials {
        name
        id
        password
      }
      result
      errors {
        message
      }
    }
  }
`;

export const VALID_PERMISSIONS = `
query ValidPermissions{
  validPermissions {
      code
      description
  }
}
`;

export const UPDATE_USER_PERMISSIONS = `
mutation UpdateUserPermissions($userId: String!, $permissions: String!){
  updateUserPermissions(userId: $userId, permissions: $permissions) {
      result
      errors{
          message
      }
  }
}
`;

export const SEND_INVITATION = `
mutation SendInvitation($email: String!, $roleName: String!){
  sendInvitation(email: $email, roleName: $roleName) {
      result
      errors{
          message
      }
  }
}
`;

export const ORGANIZE_REFERRAL_CAMPAIGN = `
mutation OrganizeReferralCampaign(
  $startDate: String!
  $endDate: String!
  $incentiveDate: String
  $promotionTitle: String!
  $promotionCost: Float!
  $redemptionLimit: Int!
  $referralId: String!
  $redirectLink: String!
  $redirectLinkBtnText: String!
  $tnc: String!
  $smsMessage: String!
  $nameholder: String!
  $title: String!
  $discountLimit: Int
  $posIntegration: String
  $ecomIntegration: String
  $shopifyProductId: String
  $expiryType: String!
  $expiryDays: Int
  $promotionType: String!
  $emailEnabled: Boolean!
  $birthdayEnabled: Boolean!
  $nameEnabled: Boolean!
  $eligibleMembers: String!
  $rebateCost: Float
  $esbItemCode: String
  $eats365ProductCode: String
  $testSmsSegments: Int!
) {
  organizeReferralCampaign(
    startDate: $startDate
    endDate: $endDate
    incentiveDate: $incentiveDate
    promotionTitle: $promotionTitle
    promotionCost: $promotionCost
    redemptionLimit: $redemptionLimit
    referralId: $referralId
    redirectLink: $redirectLink
    redirectLinkBtnText: $redirectLinkBtnText
    tnc: $tnc
    smsMessage: $smsMessage
    nameholder: $nameholder
    title: $title
    discountLimit: $discountLimit
    posIntegration: $posIntegration
    ecomIntegration: $ecomIntegration
    shopifyProductId: $shopifyProductId
    expiryType: $expiryType
    expiryDays: $expiryDays
    promotionType: $promotionType
    emailEnabled: $emailEnabled
    birthdayEnabled: $birthdayEnabled
    nameEnabled: $nameEnabled
    eligibleMembers: $eligibleMembers
    rebateCost: $rebateCost
    esbItemCode: $esbItemCode
    eats365ProductCode: $eats365ProductCode
    testSmsSegments: $testSmsSegments
  ) {
    referralId
    integrationItemCode
    errors { message }
  }
}
`;

export const SINGLE_RECHARGE_SMS_CREDITS = `
mutation SmsRechargeSingle(
  $registeredNameId: ID!
  $amount: Int!
  $quickRecharge: Boolean
){
  smsRechargeSingle(
    registeredNameId: $registeredNameId
    amount: $amount
    quickRecharge: $quickRecharge
  ) {
    result
    checkoutUrl
    errors { message }
  }
}
`;

export const ACQUISITION_URL = `
query AcquisitionUrl {
  acquisitionUrl {
    url
  }
}
`;

export const REMOVE_USER_FROM_BRAND = `
mutation RemoveUserFromBrand($email: String!) {
  removeUserFromBrand(email: $email) {
    result
    errors {
      message
    }
  }
}
`;

export const AUTOMATION_LOGS = `
query AutomationLogs($currentPage: Int!, $sort: String!, $direction: String!, $limit: Int!, $searchField: String, $searchInput: String) {
  automationLogs(currentPage: $currentPage, sort: $sort, direction: $direction, limit: $limit, searchField: $searchField, searchInput: $searchInput) {
    totalRecords
    vouchers {
      redemptionDate
      redemptionOutlet
      messageType
      customer {
        id
      }
      createdAt
      sentDate
      campaign {
        specification
        filtrationMode
        promotions {
          title
        }
      }
    }
  }
}
`;

export const AUTOMATION_REDEMPTION_REMINDER = `
query AutomationReminder(
    $filters: PromotionSearch,
    $sort: String,
    $direction: String
  ) {
  slBrand {
    id
    promotions(
      filters: $filters
      sort: $sort
      direction: $direction
    ) {
      id
      title
      promotionType
      imageUrl
      cost
      active
      toRemind
      stampConfigurations {
        status
        expiryDays
      }
      rewardDisplayName
    }
    brandConfiguration {
      id
      redemptionReminderLimit
      reminderTemplate
      reminderNameholder
      foreignRedemptionReminderEnabled
    }
  }
}
`;

export const UPDATE_REDEMPTION_REMINDER_LIMIT = `
mutation UpdateRedemptionReminderLimit($limit: Int!) {
  updateRedemptionReminderLimit(limit: $limit) {
    result
    errors {
      message
    }
  }
}
`;

export const TOGGLE_PROMOTION_TO_REMIND = `
mutation TogglePromotionToReminder($promotionId: ID!) {
  togglePromotionToRemind(promotionId: $promotionId) {
    result
    errors {
      message
    }
    promotion {
      id
      active
      toRemind
    }
  }
}
`;

export const UPDATE_REDEMPTION_REMINDER_TEMPLATE = `
mutation UpdateRedemptionReminderTemplate($newTemplate: String!, $nameholder: String) {
  updateRedemptionReminderTemplate(newTemplate: $newTemplate, nameholder: $nameholder) {
    result
    errors {
      message
    }
    brandConfiguration {
      id
      reminderTemplate
      reminderNameholder
    }
  }
}
`;

export const AUTOMATION_CAMPAIGNS = `
query AutomationCampaigns {
  automationCampaigns {
    id
    specification
    messageTypes
    smsMessageFormatted
    messageExpiryDays
    ongoing
    archived
    nameholder
    fbWsTemplateId
    filtrationMode
    promotions {
      monetaryCost
      title
      formattedType
    }
      foreignMessageEnabled
  }
}
`;

export const CREATE_AUTOMATION = `
mutation CreateAutomation(
  $automationType: String!,
  $incentiveType: String!,
  $channel: String!,
  $incentiveName: String!,
  $incentiveCost: Float!,
  $message: String!,
  $expiryDays: Int!,
  $namePlaceholder: String,
  $fbWsTemplateId: Int,
  $filtrationMode: String,
  $sbsc: Boolean!
  $discountLimit: Int
  $posIntegration: String
  $ecomIntegration: String
  $shopifyProductId: String
  $rebateCost: Float
  $esbItemCode: String
  $eats365ProductCode: String
  $testSmsSegments: Int
 ) {
  createAutomation(
    automationType: $automationType,
    incentiveType: $incentiveType,
    channel: $channel,
    incentiveName: $incentiveName,
    incentiveCost: $incentiveCost,
    message: $message,
    expiryDays: $expiryDays,
    namePlaceholder: $namePlaceholder,
    fbWsTemplateId: $fbWsTemplateId,
    filtrationMode: $filtrationMode,
    sbsc: $sbsc
    discountLimit: $discountLimit
    posIntegration: $posIntegration
    ecomIntegration: $ecomIntegration
    shopifyProductId: $shopifyProductId
    rebateCost: $rebateCost
    esbItemCode: $esbItemCode
    eats365ProductCode: $eats365ProductCode
    testSmsSegments: $testSmsSegments
  ) {
    result
    integrationItemCode
    errors {
      message
    }
  }
 }
`;

export const UPDATE_AUTOMATION = `
mutation UpdateAutomation(
  $id: ID!,
  $channels: [String!]!,
  $incentiveCost: Float,
  $archived: Boolean!,
  $foreignMessageEnabled: Boolean!
 ) {
  updateAutomation(
    id: $id,
    channels: $channels,
    incentiveCost: $incentiveCost,
    archived: $archived,
    foreignMessageEnabled: $foreignMessageEnabled
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const UPDATE_AUTOMATION_MESSAGE = `
mutation UpdateAutomationMessage(
  $id: ID!,
  $message: String!
  $testSmsSegments: Int
 ) {
  updateAutomationMessage(
    id: $id,
    message: $message,
    testSmsSegments: $testSmsSegments
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const UPDATE_AUTOMATION_EXPIRY_AND_NAMEHOLDER = `
mutation UpdateAutomationExpiryAndNameholder(
  $id: ID!,
  $expiryDays: Int!,
  $nameholder: String
 ) {
  updateAutomationExpiryAndNameholder(
    id: $id,
    expiryDays: $expiryDays,
    nameholder: $nameholder
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const ACCEPT_BRAND_INVITE = `
mutation AcceptBrandInvite($brandId: ID!) {
  acceptBrandInvite(brandId: $brandId) {
    result
    errors {
      message
    }
  }
}
`;

export const RECURRING_RECHARGE_SMS_CREDITS = `
mutation SmsRechargeRecurring(
  $registeredNameId: ID!
  $amount: Int!
  $autoRechargeThreshold: Int!
  $autoRechargeAmount: Int!
){
  smsRechargeRecurring(
    registeredNameId: $registeredNameId
    amount: $amount
    autoRechargeThreshold: $autoRechargeThreshold
    autoRechargeAmount: $autoRechargeAmount
  ) {
    result
    checkoutUrl
    errors { message }
  }
}
`;

export const CREATE_REGISTERED_NAME = `
mutation CreateRegisteredName(
  $name: String!
  $streetAddress: String!
  $postcode: String!
  $city: String!
  $state: String!
  $reusePaymentInfo: Boolean
  $reuseRegNameId: ID
  $currentPage: String!
  $fromModal: Boolean
  $companyRegNumber: String
  $sstNumber: String
  $tin: String
){
  createRegisteredName(
    name: $name
    streetAddress: $streetAddress
    postcode: $postcode
    city: $city
    state: $state
    reusePaymentInfo: $reusePaymentInfo
    reuseRegNameId: $reuseRegNameId
    currentPage: $currentPage
    fromModal: $fromModal
    companyRegNumber: $companyRegNumber
    sstNumber: $sstNumber
    tin: $tin
  ) {
    result
    id
    duplicate
    sameBrand
    existOwnerEmail
    url
    errors { message }
  }
}
`;

export const UPDATE_REGISTERED_NAME = `
mutation UpdateRegisteredName(
  $id: ID!
  $companyRegNumber: String
  $sstNumber: String
  $tin: String
) {
  updateRegisteredName(
    id: $id
    companyRegNumber: $companyRegNumber
    sstNumber: $sstNumber
    tin: $tin
  ) {
    result
    errors { message }
  }
}
`;

export const CREATE_CONTEST = `
mutation CreateContest(
  $category: String!,
  $startDate: String!,
  $endDate: String!,
  $prizeName: String!,
  $prizeExpiryDate: String!,
  $winCriteria: Int!,
  $tnc: String!,
  $minVisit: Int,
  $minSpend: Int
 ) {
  createContest(
    category: $category,
    startDate: $startDate,
    endDate: $endDate,
    prizeName: $prizeName,
    prizeExpiryDate: $prizeExpiryDate,
    winCriteria: $winCriteria,
    tnc: $tnc,
    minVisit: $minVisit,
    minSpend: $minSpend
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const CONTESTS = `
query Contests {
  contests {
    id
    category
    startDate
    endDate
    prize
    prizeExpiryDate
    winner
    minSpend
    minVisit
    status
  }
}
`;

export const MEMBERS = `
query Members ($inputs: [CustomerFilterAttributes!], $limit: Int, $currentPage: Int!, $sort: String!, $direction: String!)
{
  slBrand {
    overallUsers
    fullCustomersByFilter(inputs: $inputs, limit: $limit, currentPage: $currentPage, sort: $sort, direction: $direction) {
      filteredUserCount
      customers {
        id
        name
        email
        phoneNumber
        extension
        birthdate
        availablePoints
        collectedPoints
        collectedStamps
        completedStampCards
        latestStampCard {
          stampsCollected
          stampsToComplete
        }
        totalVisits
        totalSpending
        firstVisit
        lastVisit
        lastVisited
        durationWithBrand
        lastContacted
        blacklist
        marketingOptStatus
      }
    }
  }
}
`;

export const CREATE_TRACKED_CAMPAIGN = `
mutation CreateTrackedCampaign(
  $campaignArgs: TrackedCampaignAttributes!,
  $promotionArgs: TrackedCampaignPromotionAttributes!
 ) {
  createTrackedCampaign(
    campaignArgs: $campaignArgs,
    promotionArgs: $promotionArgs
  ) {
    result
    id
    errors {
      message
    }
  }
 }
`;

export const CAMPAIGNS = `
query SlCampaigns($specification: String!){
  slCampaigns(specification: $specification){
    id
    title
    promotions{
      id
      title
      promotionType
    }
  }
}
`;

export const MANUAL_CAMPAIGN = `
query brandManualCampaigns($id: ID!) {
  brand(id: $id) {
      id
      name
      countryCode
      expiredAnnouncements {
        id
        title
        roi
      }

      expiredManualCampaign {
        id
        title
        roi
      }
    }
  }
`;

export const BRAND_REFERRALS = `
query brandReferrals(
  $index: Int!
  $outletId: ID
) {
  brandReferrals(
    index: $index
    outletId: $outletId
  ) {
    id
    title
    startDate
    endDate
    active
    revenue
    clicks
    conversions
    redemptions
  }
}
`;

export const BRAND_REFERRALS_CHARTS = `
query brandReferralsChart(
  $index: Int!
  $campaignId: ID!
) {
  brandReferralsChart(
    index: $index
    campaignId: $campaignId
  ) {
    id
    title
    startDate
    endDate
    active
    data {
        chartPeriod
        clicks
        redemptions
    }
  }
}
`;

export const SL_CUSTOMER = `
query SlCustomer($id: ID, $phoneNumber: String, $extension: String, $name: String){
  slCustomer(id: $id, phoneNumber: $phoneNumber, extension: $extension, name: $name){
    id
    name
    email
    emailStatus
    instagramHandles
    phoneNumber
    extension
    birthdate
    availablePoints
    collectedPoints
    collectedStamps
    completedStampCards
    totalVisits
    totalSpending
    firstCollection
    lastCollection
    lastVisited
    durationWithBrand
    blacklist
    metaVerified
    marketingOptStatus
    mostVisitedOutlet
    visitedOutletTimes
    totalCollections
    totalRedemptions
    firstVisit
    lastVisit
    age
    specification
    membership {
      title
      color
    }
    latestStampCard {
      stampsCollected
      stampsToComplete
    }
    instaProfile{
      name
      handle
      profilePictureUrl
    }
    privilegeCardsRedemptions {
      id
      expiryDate
      createdAt
      status
      privilegeCardConfiguration {
        id  
        privilegeName
        rewardName
        privilegeImageUrl
        backgroundColor
        primaryTextColor
        labelTextColor
        promotion {
          title
          cost
          promotionType
          monetaryCost
          discountLimit
          posSettings {
            name
            enabled
          }
        }
      }
    }
  }
}
`;

export const REGISTERED_NAMES = `
query SlRegisteredNames {
  slRegisteredNames {
    registeredNames {
      id
      name
      streetAddress
      postcode
      city
      state
      tin
      companyRegNumber
      sstNumber
    }
    lastUsedId
  }
}
`;

export const COMPANY_NAMES = `
query CompanyNames {
  slRegisteredNames {
    registeredNames {
      id
      name
    }
  }
}
`;

export const UPDATE_USER_ROLE = `
mutation UpdateUserRole($id: ID!, $name: String, $permissions: String){
  updateUserRole(id: $id, name: $name, permissions: $permissions){
    result
    errors{
      message
    }
  }
}
`;

export const CREATE_INVOICE_SETTINGS = `
mutation CreateInvoiceSettings(
  $registeredNameId: ID!
  $emailPaidInvoice: Boolean!
  $emailAddress: String
){
  createInvoiceSettings(
    registeredNameId: $registeredNameId
    emailPaidInvoice: $emailPaidInvoice
    emailAddress: $emailAddress
  ) {
    result
    errors { message }
  }
}
`;

export const USER_ROLES = `
query UserRoles($excludeOwner: Boolean, $excludeAdmin: Boolean) {
  userRoles(excludeOwner: $excludeOwner, excludeAdmin: $excludeAdmin) {
    id
    name
    permissions {
      name
      read
      modify
      download
  }
  }
}
`;

export const TOGGLE_CAMPAIGN_ONGOING = `
mutation ToggleCampaignOngoing($id: ID!) {
  toggleCampaignOngoing(id: $id) {
    result
    errors {
      message
    }
  }
}
`;

export const BROADCAST_CUSTOMERS_BY_EXTENSION = `
query BroadcastCustomersByExtension(
  $inputs: [CustomerFilterAttributes!]!
  $exclusive: Boolean
  $byLeads: Boolean
  $channel: String
) {
  slBrand {
    id
    broadcastCustomersByExtension(inputs: $inputs, exclusive: $exclusive, byLeads: $byLeads, channel: $channel)
  }
}
`;

export const BRAND_CUSTOMER_FILTER_WITH_ID = `
query BrandCustomerFilterWithId(
  $inputs: [CustomerFilterAttributes!]!
) {
  slBrand {
    id
    customersByFilter(inputs: $inputs)
  }
}
`;

export const SEND_SMS_TEST = `
mutation SendSmsTest(
  $numbers: [String!]!
  $smsMessage: String!
  $brandId: ID!
  $nameholder: String!
  $expiry: String
  $promoName: String
  $promoCost: Int
  $tierLevelName: String
) {
  sendSmsTest(
    numbers: $numbers
    smsMessage: $smsMessage
    brandId: $brandId
    nameholder: $nameholder
    expiry: $expiry
    promoName: $promoName
    promoCost: $promoCost
    tierLevelName: $tierLevelName
  ) {
    result
    smsSplit
    smsCost
    errors {
      message
    }
  }
}
`;

export const SEND_MANUAL_SMS = `
mutation SendManualSms(
  $brandId: ID!
  $filterArgs: SmsScreenFilterAttributes!
  $campaignArgs: SmsScreenCampaignAttributes!
  $scheduleArgs: SmsScreenScheduleAttributes!
  $promotionArgs: SmsScreenPromotionAttributes!
  $metadata: [String!]!
  $targetOpt: SmsScreenFilterAttributes!
) {
  organizeManualCampaignV2(
  brandId: $brandId
  filterArgs: $filterArgs
  campaignArgs: $campaignArgs
  scheduleArgs: $scheduleArgs
  promotionArgs: $promotionArgs
  metadata: $metadata
  targetOpt: $targetOpt
  ) {
    result
    integrationItemCode
    errors {
      message
    }
  }
}
`;

export const SEND_ANNOUNCEMENT_SMS = `
mutation SendAnnouncementSms(
  $brandId: ID!
  $filterArgs: SmsScreenFilterAttributes!
  $campaignArgs: SmsScreenCampaignAttributes!
  $scheduleArgs: SmsScreenScheduleAttributes!
  $metadata: [String!]!
  $targetOpt: SmsScreenFilterAttributes!
) {
  organizeAnnouncementCampaignV2(
  brandId: $brandId
  filterArgs: $filterArgs
  campaignArgs: $campaignArgs
  scheduleArgs: $scheduleArgs
  metadata: $metadata
  targetOpt: $targetOpt
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const CREATE_BROADCAST_EMAIL_TEMPLATE = `
mutation CreateBroadcastEmailTemplate(
  $content: String!
  $subject: String!
  $preheader: String!
  $ctaIds: [ID!]
) {
  createBroadcastEmailTemplate(
    content: $content
    subject: $subject
    preheader: $preheader
    ctaIds: $ctaIds
  ) {
    template {
      id
    }
    errors {
      message
    }
  }
}
`;

export const CREATE_CTA_BROADCAST_EMAIL = `
mutation CreateCtaBroadcastEmail(
  $ctaUrl: String!
) {
  createCtaBroadcastEmail(
    ctaUrl: $ctaUrl
  ) {
    broadcastEmailAction {
      id
      ctaUrl
    }
    errors {
      message
    }
  }
}
`;

export const SEND_TEST_EMAIL = `
mutation SendTestEmail(
  $subject: String!
  $preheader: String!
  $content: String!
  $recipients: [String!]!
  $nameholder: String!
  $expiry: String
  $promoName: String
) {
  sendTestEmail(
    subject: $subject
    preheader: $preheader
    content: $content
    recipients: $recipients
    nameholder: $nameholder
    expiry: $expiry
    promoName: $promoName
  ) {
    result
    messageId
    errors { message }
  }
}
`;

export const GET_WHATSAPP_USERS_PROFILE = `
  query CustomerInformations($currentPage: Int!, $limit: Int!){
    customerInformations(currentPage: $currentPage, limit: $limit) {
      pictureUrl
      name
    }
  }
`;

export const GET_NEWSFEED = `
  query newsfeed($limit: Int!, $currentPage: Int!){
    newsfeed(limit: $limit, currentPage: $currentPage) {
      results {
        id
        redeemedPoints
        spending
        outlet {
          name
        }
        name
        pictureUrl
        createdAt
      }
      totalPages
    }
  }
`;

export const GET_TOP_MEMBERS = `
  query TopMembers{
    topMembers {
      id
      name
      pictureUrl
      totalSpending
      totalVisits
      createdAt
    }
  }
`;

export const GET_POINTS = `
query collectedPoints($index: Int!){
    collectedPoints(index: $index) {
      startDate
      records {
        monthStart
        totalAmount
        name
        message
      }
    }
  }`;

export const GET_POINTS_COUNT = `
query collectedPoints($index: Int!){
    collectedPoints(index: $index) {
      startDate
      records {
        monthStart
        count
        name
        message
      }
    }
  }`;

export const GET_COLLECTED_STAMPS = `
query collectedStamps($index: Int!){
    collectedStamps(index: $index) {
      startDate
      records {
        monthStart
        totalAmount
        name
        message
      }
    }
  }`;

export const GET_REDEEMED = `
query pointsRedeemed($index: Int!){
    pointsRedeemed(index: $index) {
      startDate
      records {
        monthStart
        totalCost
        name
        message
      }
    }
  }`;

export const GET_REDEEMED_COUNT = `
query pointsRedeemed($index: Int!){
    pointsRedeemed(index: $index) {
      startDate
      records {
        monthStart
        count
        name
        message
      }
    }
  }`;

export const GET_ITEM = `
query ItemsRedeemed($period: String!, $outletId: ID){
    itemsRedeemed(period: $period, outletId: $outletId) {
      title
      count
      name
      message
    }
  }`;

export const GET_ACTIVE_HOURS = `
query ActiveHours($index: Int!){
    activeHours(index: $index) {
      count
      hours
      name
      message
    }
  }`;

export const GET_AVERAGE_DATA_COLLECTED = `
query MostActiveDays($index: Int!){
    mostActiveDays(index: $index) {                
      averageMondayCount
      averageTuesdayCount
      averageWednesdayCount
      averageThursdayCount
      averageFridayCount
      averageSaturdayCount
      averageSundayCount
      name
      message
    }
  }
`;

export const TOTAL_BRAND_CREDIT = `
query TotalBrandCredit {
  totalBrandCredit {
    amount
  }
}
`;

export const SMS_RECHARGE_COST = `
query SmsRechargeCost($amount: Int!) {
  smsRechargeCost(amount: $amount) {
    taxName
    tax
    costAfterTax
  }
}
`;

export const SMS_RECHARGE_COST_RECURRING = `
query SmsRechargeCostRecurring($amount: Int!) {
  smsRechargeCostRecurring(amount: $amount) {
    taxName
    tax
    costAfterTax
  }
}
`;

export const TOP_PERFORMING_PROMOTIONAL_BROADCAST = `
  query topPerformingPromotionalBroadcast($id: ID!, $timeRange: Int) {
    brand(id: $id) {
      name
      countryCode
      expiredManualCampaign(timeRange: $timeRange) {
        id
        title
        expiryDate
        sentDate 
        totalCollections
        roi
        returns
        targetAmount
      }
    }
  }
`;

// export const NEW_MEMBERS_COUNT = `
//   query newMemberReports(
//     $period: Int!
//     $outletId: ID
//     ) {
//     newMemberReports(
//       period: $period
//       outletId: $outletId
//       ) {
//         reportMonth
//         reportYear
//         newMembers
//         medianNewMembers
//     }
//   }
// `;

export const MEMBERS_MONTHLY_VISIT_COUNT = `
  query MonthlyVisitReports(
    $period: Int!
    $outletId: ID
  ){
    monthlyVisitReports(
      period: $period
      outletId: $outletId
    ){
      reportMonth
      reportYear
      count1
      count2
      count3
      count4More
    }
  }
`;

export const MEMBERS_MONTHLY_VALUE_COUNT = `
  query monthlyValue(
    $period: Int!
    $outletId: ID
  ){
    monthlyValueReports(
      period: $period
      outletId: $outletId
    ){
      reportMonth
      reportYear
      count25
      count50
      count75
      count100
      quartile1Bound
      quartile2Bound
      quartile3Bound
      quartile4Bound
    }
  }
`;

export const MEMBERS_DATA_ACQUISITION_COST = `
  query DataAcquisitionCostReports(
    $period: Int!
    $outletId: ID
  ){
    dataAcquisitionCostReports(
      period: $period
      outletId: $outletId
    ) {
      reportMonth
      reportYear
      cost
      medianCost
    }
  }
`;

export const MEMBERS_RETURN_RATE = `
  query returnRate(
    $period: Int!
    $outletId: ID
  ){
    returnRateReports(
      period: $period
      outletId: $outletId
    ) {
      reportMonth
      reportYear
      returnRate
      medianReturnRate
    }
  }
`;

export const MEMBERS_LIFETIME_VALUE = `
  query LtvReports(
    $period: Int!
    $outletId: ID
  ) {
    ltvReports(
      period: $period
      outletId: $outletId
    ) {
      reportMonth
      reportYear
      ltv
      medianLtv
    }
  }
`;

export const MEMBERS_MOST_RECENT_PURCHASE = `
  query membersMrp($outletId: ID) {
    mrpReports(outletId: $outletId) {
      months03
      months36
      months69
      months912
      months1215
      months1518
      months1824
      months24More
    }
  }
`;

export const ACTIVE_MEMBERS = `
  query ActiveMembers(
    $outletId: ID
  ) {
    activeMembers (
      outletId: $outletId
    ) {
        brandId
        activeMembers
    }
  }
`;

export const ACTIVE_PRIVILEGE_MEMBERS = gql`
  query ActivePrivilegeMembers(
    $privilegeCardConfigurationId: ID!
    $filter: String
    $searchInput: String
    $searchField: String
    $first: Int
    $after: String
    $active: Boolean
  ) {
    slBrand {
      privilegeMembers(
        privilegeCardConfigurationId: $privilegeCardConfigurationId
        filter: $filter
        searchInput: $searchInput
        searchField: $searchField
        first: $first
        after: $after
        active: $active
      ) {
        edges {
          node {
            id
            name
            email
            phoneNumber
            extension
            privilegeCardRedemption(
              privilegeCardConfigurationId: $privilegeCardConfigurationId
            ) {
              id
              expiryDate
              status
              createdAt
              provider
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const BRAND_OUTLETS = `
query SlBrand {
  slBrand {
    outlets {
      id
      name
      active
      markedAsDelete
      specialType
    }
  }
}
`;

export const BROADCAST_OUTLETS = `
query SlBrand($channel: String) {
  slBrand {
    outletBroadcast  {
      id
      name
      active
      markedAsDelete
      memberCount(channel: $channel)
    }
  }
}
`;

export const AVERAGE_MEMBER_VISITS = `
query AverageMemberVisits (
  $period: Int!, 
  $outletId: ID
  ) {
  averageMemberVisits (
    period: $period, 
    outletId: $outletId
    ) {
      reportMonth
      reportYear
      movingTotalVisits
      movingTotalMembers
      movingTotalPoints
      medianMemberPoints
      averageMemberVisits
      medianMemberVisits
  }
}
`;

export const LATEST_MONTH_AVERAGE_VISITS = `
query CurrentAverageMemberVisit {
  currentAverageMemberVisit {
      reportMonth
      reportYear
      movingTotalVisits
      movingTotalMembers
      movingTotalPoints
      medianMemberPoints
      averageMemberVisits
  }
}
`;

export const CUSTOMER_SMS_LOGS = `
query CustomerSmsLogs($customerId: ID!, $hidden: Boolean!) {
  customerSmsLogs(customerId: $customerId, hidden: $hidden) {
    id
    brandName
    message
    datetime
    channel
  }
}
`;

export const MEMBER_ACTIVITIES = `
query MemberActivities($customerId: ID!) {
  memberActivities(customerId: $customerId) {
    datetime
    transactionType
    spending
    stamps
    points
    storeName
    rewardName
    validated
    voided
    groupRecredit
    groupExpired
    expiryDate
  }
}
`;

export const FILTER_MEMBERS = `
query FilterMembers($filters: [FilterMembersCriteria!]!) {
  filterMembers(filters: $filters) {
    filteredCount
  }
}
`;

export const MONTHLY_REPORTS = `
  query MontlyReports($year: Int!, $month: Int!) {
    slBrand {
      id
      monthlyReports(year: $year, month: $month)
      outlets {
        id
        name
        monthlyReports(year: $year, month: $month)
      }
      createdAt
    }
  }
`;

export const BRAND_PLAN_LIMITS = `
query BrandPlanLimit{
  brandPlanLimit {
    plan {
      name
    }
    messagesUsed
    messageLimit
    databaseUsed
    databaseLimit
    nextResetDays
    freeTrialUsed
    wsNumberLimit
    trialDaysLeft
  }
}
`;

export const BRAND_EXPIRIES = `
query BrandExpiries{
  slBrand {
    brandExpiries {
      days
      monthInterval
      startMonth
      active
      periods
    }
  }
}
`;

export const ADD_BRAND_EXPIRY = `
mutation addBrandExpiry(
  $year: Int!, 
  $monthInterval: Int!,
  $startMonth: Int
  ) {
  addBrandExpiry(
    year: $year, monthInterval: 
    $monthInterval, 
    startMonth: $startMonth
    ) {
    result
    errors {
      message
    }
  }
}
`;

export const GET_BRAND_EXPIRY = `
mutation previewBrandExpiry(
  $year: Int!, 
  $monthInterval: Int!, 
  $startMonth: Int!
  ) {
  previewBrandExpiry(
    year: $year, 
    monthInterval: $monthInterval, 
    startMonth: $startMonth
    ) {
      result
      errors {
        message
      }
  }
}
`;

export const WEEKLY_INSIGHT = `
  query BrandsInsight(
    $startDate: String
    $endDate: String
  ) {
    brandCampaignInsightWeekly(
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      weeklyInsights {
        outletId
        name
        week
        year
        roi
        smsRedeemed
        startDate
        endDate
      }
    }
  }
`;

export const MONTHLY_BROADCAST_ANALYTICS_REPORTS = `
query MonthlyBroadcastAnalyticsReports(
  $period: String!
  $outletId: ID
  ) {
  monthlyBroadcastAnalyticsReports(
    period: $period
    outletId: $outletId
    ) {
      reportMonth
      reportYear
      roi
      increasedProfit
      allSmsSent
      smsRedeemed
      totalCollection
      organizerId
      specification
      avgConversion
      startDate
      endDate
      incentive
  }
}
`;

export const WEEKLY_BROADCAST_ANALYTICS_REPORTS = `
query WeeklyBroadcastAnalyticsReports(
  $outletId: ID
  ) {
  weeklyBroadcastAnalyticsReports(
    outletId: $outletId
    ) {
      roi
      week
      totalCollection
      outletId
  }
}
`;

export const MONTHLY_INCENTIVE_ANALYTICS_REPORT = `
query MonthlyIncentiveAnalyticsReports(
  $period: String!
  $outletId: ID
  ) { 
  monthlyIncentiveAnalyticsReports(
    period: $period
    outletId: $outletId
    ) {
      reportMonth
      reportYear
      roi
      increasedProfit
      smsSent
      smsRedeemed
      smsExpired
      specification
      incentive
  }
}
`;

export const SPECIFIC_INCENTIVE_ANALYTICS_REPORT = `
query TargetedIncentiveAnalyticsReports(
  $campaignId: ID!
) {
  targetedMonthlyIncentiveAnalyticsReports(
    campaignId: $campaignId
  ) {
      roi
      increasedProfit
      reportMonthInt
      reportYear
      roiCount
      conversions
      smsRedeemed
      smsDelivered
      visitPer
      totalCost
      roas
      outletName
      offerCost
      cogsCost
      smsCost
      smsCostBillingCurrency
      salesPerc {
        cpPerc
        cpcPerc
        roasPerc
        reachPerc
        additionalSalesPerc
      }
      sbsc
      startDate
  }
}
`;

export const GET_REPORTS_DETAILS = `
query reportDetails($outletId: ID, $startDate: String, $endDate: String) {
	reportDetails(outletId: $outletId, startDate: $startDate, endDate: $endDate) {
		date
		collections
		transactions
		newMember
    closed
    event
	}
}
`;

export const OUTLET_MISS_REPORTS = `
query missReportOutlets($startDate: String, $endDate: String) {
  missReportOutlets(startDate: $startDate, endDate: $endDate) {
    outletId
    name
    dates
  }
}`;

export const GET_OUTLET_TABLES = `
query outletTables(
  $outletId: ID!
  ) {
  outletTables(outletId: $outletId) {
    id
    tableNumber
  }
}
`;

export const CREATE_OUTLET_TABLE = `
mutation createOutletTable(
  $tableNumber: String!
  $outletId: ID!
) {
  createOutletTable(
    tableNumber: $tableNumber
    outletId: $outletId
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const DELETE_OUTLET_TABLE = `
mutation deleteOutletTable(
  $tableId: ID!
) {
  deleteOutletTable(
    tableId: $tableId
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const TOGGLE_USHER_MODE = `
mutation toggleBrandUsherMode{
  toggleBrandUsherMode {
    result
    errors {
      message
    }
  }
}
`;

export const STORE_SECURITY_SETTINGS = `
query slBrand{
  slBrand {
    countryCode
    securityCode
    securityCodes {
      code
      assignedTo
      id
    }
    collectionLimit
    medianSpend
    brandConfiguration {
      collectionTransaction
      redemptionTransaction
      redemptionFrequencyLimit
      redemptionItemLimit
      unverifiedEmailRedemptionLimit
      ekyc {
        fbRequired
        redeemThreshold
        collectThreshold
        spentThreshold
      }
    }
  }
}
`;

export const GENERATE_SECURITY_CODE = gql`
  mutation generateBrandSecurityCode($assignedTo: String!, $id: ID) {
    generateBrandSecurityCode(assignedTo: $assignedTo, id: $id) {
      errors {
        message
      }
    }
  }
`;

export const UPDATE_SECURITY_CODE_ASSIGNEE = gql`
  mutation updateBrandSecurityCodeAssignee($id: ID!, $assignedTo: String!) {
    updateBrandSecurityCodeAssignee(id: $id, assignedTo: $assignedTo) {
      result
      errors {
        message
      }
    }
  }
`;

export const REMOVE_SECURITY_CODE = gql`
  mutation removeBrandSecurityCode($id: ID!) {
    removeBrandSecurityCode(id: $id) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGLLE_TRANSACTION_PACKAGE = `
mutation toggleTransactionPackage($spec: String!){
  toggleTransactionPackage(spec: $spec) {
    result
    errors {
      message
    }
  }
}
`;

export const ADD_COLLECTION_LIMIT = `
mutation addCollectionLimit($limit: Int!){
  addCollectionLimit(limit: $limit) {
    errors {
      message
    }
  }
}
`;

export const EDIT_REDEMPTION_SECURITY_CONFIG = `
mutation editRedemptionSecurityConfig(
  $frequencyLimit: Int
  $itemLimit: Int
){
  editRedemptionSecurityConfig(
    frequencyLimit: $frequencyLimit
    itemLimit: $itemLimit
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const CUSTOMER_BRAND_BLACKLIST = `
query customerBrandBlacklist($spec: String) {
  customerBrandBlacklist(spec: $spec) {
    customer {
      id
      name
      phoneNumber
      totalVisits
      collectedPoints
    }
    createdAt
  }
}
`;

export const BLOCK_CUSTOMERS_FROM_COLLECTION = `
mutation blockCustomersFromCollection(
    $spec: String!, 
    $target: String!
  ){
  blockCustomersFromCollection(
    spec: $spec
    target: $target
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const USER_REFERRAL_TOKEN = `
query Users{
  users {
      id
      email
      referralToken
  }
}
`;

export const REGISTRATION_REFERRAL = `
query registrationReferral {
  registrationReferrals {
    invitedEmails
    registeredEmails
  }
}
`;

export const REGISTER_NEW_REFERRAL = `
mutation registerNewReferral($email: String!) {
  registerNewReferral(email: $email) {
    result
    errors
  }
}
`;

export const UPDATE_REFERRAL_STATUS = `
mutation updateReferralStatus($email: String!, $referralToken: String!) {
  updateReferralStatus(email: $email, referralToken: $referralToken) {
    result
    errors {
      message
    }
  }
}
`;

export const CHECK_VALID_TOKEN = `
  mutation checkReferralToken($referralToken: String!) {
    checkReferralToken(referralToken: $referralToken) {
      result
      errors {
        message
      }
    } 
  }
`;

export const CREATE_EMAIL_SUBSCRIPTION = `
  mutation CreateEmailSubscription($email: String! $subscribed: Boolean!) {
    createEmailSubscription(email: $email, subscribed: $subscribed ) {
      result
      errors {
        message
      }
    }
  }
`;

export const SEND_UNTRACKED_MESSAGE = `
mutation SendUntrackedMessage($customerId: ID!, $message: String!, $messageType: String!) {
  sendUntrackedMessage(customerId: $customerId, message: $message, messageType: $messageType) {
    result
    errors {
      message
    }
  }
}
`;

export const SEND_TRACKED_MESSAGE = `
mutation SendTrackedMessage($campaignId: ID!, $customerId: ID!) {
  sendTrackedMessage(campaignId: $campaignId, customerId: $customerId) {
    result
    message
    errors {
      message
    }
  }
}
`;

export const TRACKED_CAMPAIGNS = `
query SlCampaigns($specification: String!){
  slCampaigns(specification: $specification){
    id
    title
    messageExpiryDays
    expiryDate
    messageTypes
    promotions{
      id
      title
      promotionType
    }
  }
}
`;

export const TOGGLE_PRIVACY_MODE = `
  mutation TogglePrivacyMode {
    togglePrivacyMode {
      result
      errors {
        message
      }
    }
  }`;

export const RESET_STORE_PASSWORD = `
  mutation ResetStorePassword($outletId: ID!) {
    resetStorePassword (outletId: $outletId) {
      result
      sentTo
      errors {
        message
      }
    }
  }`;

export const BRAND_CONFIGURATION = `
query SlBrand {
  slBrand {
    id
    perOutletRate
    underSubscription
    customerInquiry
    brandConfiguration {
      usherMode
      privacyMode
      redemptionOnly
      allowSkipEmail
      needEmailVerification
      restrictRemarketing
      foreignBroadcastEnabled
      reportingType
    }
  }
}
`;
export const BRAND_PRIVACY_NOTICE = `
query SlBrand {
  slBrand {
    marketingNoticeText
    portalOptText
  }
}
`;

export const UPDATE_BRAND_PRIVACY_NOTICE = `
mutation UpdateBrandPrivacyNotice($marketingNoticeText: String!, $portalOptText: String!) {
  updateBrandPrivacyNotice(marketingNoticeText: $marketingNoticeText, portalOptText: $portalOptText) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_REPORTING_TYPE = `
mutation UpdateReportingType($brandId: ID!, $reportingType: String!) {
  updateReportingType(brandId: $brandId, reportingType: $reportingType) {
    result
    errors {
      message
    }
  }
}
`;

export const TOGGLE_RESTRICT_REMARKETING = `
  mutation toggleRestrictRemarketing {
    toggleRestrictRemarketing {
      result
      errors {
        message
      }
    }
  }
`;

export const GET_BRAND_SLUG = `
  query SlBrand($brandId: ID!) {
    slBrand(brandId: $brandId) {
      slug
      membershipType
      groupMembershipType
    }
  }
`;

export const MONTHLY_AUTOMATION_REPORT = `
query MonthlyAutomationReports(
  $period: Int!
  $outletId: ID
  ) { 
  monthlyAutomationReports(
    period: $period
    outletId: $outletId
    ) {
      reportMonth
      reportYear
      roi
  }
}
`;

export const HIDDEN_PERMISSIONS = `
query HiddenPermissions{
  hiddenPermissions {
    name
    hiddenSubperms
  }
}
`;

export const UPDATE_POINTS_BALANCE_LIMIT = `
mutation UpdatePointsBalanceLimit(
  $pointsLimit: Int!
  ) { 
  updatePointsBalanceLimit(
    pointsLimit: $pointsLimit
    ) {
      result
      errors {
        message
      }
  }
}
`;

export const BRAND_CONFIGURATION_REMINDER = `
  query SlBrand {
    slBrand {
      brandConfiguration {
        pointReminderEnabled
        pointsBalanceLimit
        limitMaxPoints
      }
    }
  }
`;

export const TOGGLE_LIMIT_MAX_POINTS = `
  mutation ToggleLimitMaxPoints {
    toggleLimitMaxPoints {
      result
      errors {
        message
      }
    }
  }
`;

export const CUSTOMER_SEARCH = `
query CustomerSearch(
  $searchName: String!
) {
  customerSearch(
    searchName: $searchName
  ) {
    name
    id
  }
}
`;

export const VALIDATE_USER_CREDENTIALS = `
mutation validateUserCredentials($password: String!) {
  validateUserCredentials (password: $password) {
    result
    errors {
      message
    }
  }
}`;

export const DELETE_BRAND_OWNER = `
mutation deleteBrandOwner($userId: ID!) {
  deleteBrandOwner(userId: $userId) {
    result
    errors {
      message
    }
  }
}
`;

export const GENERATE_OWNER_VERIFICATION_CODE = `
mutation generateOwnerVerificationCode($newOwnerId: ID!){
  generateOwnerVerificationCode(newOwnerId: $newOwnerId) {
    result
    errors{
      message
    }
  }
}
`;

export const VALIDATE_OWNER_VERIFICATION_CODE = `
mutation validateOwnerVerificationCode($newOwnerId: ID!, $verificationCode: String!){
  validateOwnerVerificationCode(newOwnerId: $newOwnerId, verificationCode: $verificationCode) {
    result
    errors{
      message
    }
  }
}
`;

export const BRAND_CUSTOM_FIELD_SETTING = `
  query BrandCustomFieldSetting {
    brand {
      id
      brandCustomFieldSetting {
        firstFieldEnabled
        firstFieldTitle
        firstFieldResponseType
        firstFieldResponseValue
        secondFieldEnabled
        secondFieldTitle
        secondFieldResponseType
        secondFieldResponseValue
        thirdFieldEnabled
        thirdFieldTitle
        thirdFieldResponseType
        thirdFieldResponseValue
      }
    }
  }
`;

export const UPDATE_BRAND_CUSTOM_FIELD_SETTING = `
  mutation UpdateBrandCustomFieldSetting(
    $firstFieldEnabled: Boolean
    $firstFieldTitle: String
    $firstFieldResponseType: String
    $firstFieldResponseValue: [String!]
    $secondFieldEnabled: Boolean
    $secondFieldTitle: String
    $secondFieldResponseType: String
    $secondFieldResponseValue: [String!]
    $thirdFieldEnabled: Boolean
    $thirdFieldTitle: String
    $thirdFieldResponseType: String
    $thirdFieldResponseValue: [String!]
  ) {
    updateBrandCustomFieldSetting(
      firstFieldEnabled: $firstFieldEnabled
      firstFieldTitle: $firstFieldTitle
      firstFieldResponseType: $firstFieldResponseType
      firstFieldResponseValue: $firstFieldResponseValue
      secondFieldEnabled: $secondFieldEnabled
      secondFieldTitle: $secondFieldTitle
      secondFieldResponseType: $secondFieldResponseType
      secondFieldResponseValue: $secondFieldResponseValue
      thirdFieldEnabled: $thirdFieldEnabled
      thirdFieldTitle: $thirdFieldTitle
      thirdFieldResponseType: $thirdFieldResponseType
      thirdFieldResponseValue: $thirdFieldResponseValue
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const GENERATE_DELETE_CUSTOM_FIELD_DATA = `
  mutation GenerateDeleteCustomFieldData {
    generateDeleteCustomFieldData {
      result
      errors {
        message
      }
    }
  }
`;

export const VALIDATE_DELETE_CUSTOM_FIELD_DATA = `
  mutation ValidateDeleteCustomFieldData($code: String!, $field: String!) {
    validateDeleteCustomFieldData(code: $code, field: $field) {
      result
      errors {
        message
      }
    }
  }
`;

// Integrations
export const BRAND_ECOMMERCE_CONFIGURATION = `
  query BrandShopify {
    brand {
      id
      brandConfiguration {
        id
        shopifyEnabled
        magentoEnabled
      }
      magentoTemplates {
        websiteIds
        customerGroupIds
      }
    }
  }
`;

export const BRAND_ECOMMERCE_PROMOTIONS = `
  query BrandShopify {
    brand {
      id
      shopifyPromotions {
        id
        name
        discountAmount
        cost
        active
      }
      magentoPromotions {
        id
        name
        cost
        discountAmount
        active
      }
    }
  }
`;

// Xilnex
export const UPDATE_XILNEX_API_ID = `
  mutation updateXilnexApiId(
    $outletId: ID!
    $xilnexApiId: String
  ) {
    updateXilnexApiId(
      outletId: $outletId
      xilnexApiId: $xilnexApiId
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const ENABLE_XILNEX_FTP = `
mutation {
  enableXilnexFtp {
    result
    otherPos
    errors {
      message
    }
  }
}
`;

export const UPDATE_XILNEX_CREDENTIALS = `
  mutation updateXilnexCredentials(
    $appId: String!
    $appToken: String!
  ) {
    updateXilnexCredentials(
      appId: $appId
      appToken: $appToken
    ) {
      result
      otherPos
      verified
      updatedAt
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_XILNEX_REDEMPTION_ENABLED = `
  mutation ToggleXilnexRedemptionEnabled($enabled: Boolean!) {
    toggleXilnexRedemptionEnabled(enabled: $enabled) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const UNLINK_XILNEX = `
mutation UnlinkXilnex($code: String!){
  unlinkXilnex(code: $code) {
    result
    errors {
      message
    }
  }
}
`;

export const UNLINK_XILNEX_FTP = `
mutation UnlinkXilnexFtp($code: String!) {
  unlinkXilnexFtp(code: $code) {
    result
    errors {
    message
    }
  } 
}
`;

// Zeoniq
export const UPDATE_ZEONIQ_ID = `
  mutation UpdateZeoniqId(
    $linkId: ID!,
    $zeoniqId: String!
  ) {
    updateZeoniqId (
      linkId: $linkId,
      zeoniqId: $zeoniqId
    ) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const UNLINK_ZEONIQ = `
mutation UnlinkZeoniq($code: String!) {
  unlinkZeoniq(code: $code) {
    result
    errors {
      message
    }
  }
}
`;

// Shopify
export const CREATE_SHOPIFY_PROMOTION = `
  mutation CreateShopifyPromotion(
    $brandId: ID!
    $name: String!
    $display: String!
    $cost: Int!
    $discountAmount: Float!
    $shopifyProductId: String
    $minimumSpending: Float!
  ) {
    createShopifyPromotion(
      brandId: $brandId
      name: $name
      display: $display
      cost: $cost
      discountAmount: $discountAmount
      shopifyProductId: $shopifyProductId
      minimumSpending: $minimumSpending
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_SHOPIFY_REDEMPTION_WEBHOOK = `
  mutation ToggleShopifyRedemptionWebhook {
    toggleShopifyRedemptionWebhook {
      result
      otherEcom
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_SHOPIFY_PROMOTION = `
  mutation ToggleShopifyPromotion(
    $id: ID!
  ) {
    toggleShopifyPromotion (
      id: $id
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_SHOPIFY_COLLECTION_WEBHOOK = `
  mutation ToggleShopifyCollectionWebhook($enabled: Boolean!) {
    toggleShopifyCollectionWebhook(enabled: $enabled) {
    otherEcom  
    result
      errors {
        message
      }
    }
  }
`;

export const UNLINK_SHOPIFY = `
mutation UnlinkShopify($code: String!) {
  unlinkShopify(code: $code) {
    result
    errors {
      message
    }
  }
}
`;

// Magento
export const UPDATE_MAGENTO_SETTINGS = `
  mutation UpdateMagentoSettings(
    $accessToken: String!
    $endpoint: String!
    $prefix: String!
  ) {
    updateMagentoSettings(
      accessToken: $accessToken
      endpoint: $endpoint
      prefix: $prefix
    ) {
      result
      verified
      errors {
        message
      }
    }
  }
`;

export const CREATE_MAGENTO_PROMOTION = `
  mutation CreateMagentoPromotion(
    $brandId: ID!
    $name: String!
    $display: String!
    $cost: Int!
    $discountAmount: Float!
    $websiteIds: [Int!]!
    $customerGroupIds: [Int!]!
  ) {
    createMagentoPromotion(
      brandId: $brandId
      name: $name
      display: $display
      cost: $cost
      discountAmount: $discountAmount
      websiteIds: $websiteIds
      customerGroupIds: $customerGroupIds
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_MAGENTO_ENABLED = `
  mutation ToggleMagentoEnabled {
    toggleMagentoEnabled {
      result
      otherEcom
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_MAGENTO_PROMOTION = `
  mutation ToggleMagetoPromotion($id: ID!) {
    toggleMagentoPromotion(id: $id) {
      result
      errors {
        message
      }
    }
  }
`;

export const STORE_REPORT_RECIPIENTS = `
query StoreReportRecipients {
  storeReportRecipients {
      outletId
      outletName
      userIds
      outlet {
        id,
        active,
        markedAsDelete
      }
  }
}
`;

export const UPDATE_STORE_REPORT_RECIPIENTS = `
mutation UpdateStoreReportRecipients(
  $outletId: ID!
  $userIds: [ID!]!
) {
  updateStoreReportRecipients(
  outletId: $outletId
  userIds: $userIds
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const BRAND_POINT_MULTIPLIER = `
  query BrandPointMultiplier(
    $first: Int
    $after: String
    $active: Boolean!
  ){
    brandPointMultiplier(first: $first, after: $after, active: $active) {
      edges {
        node{
          id
          starting
          ending
          multiplier
          active
          eventName
          rruleData
          membersCollected
          totalCollections
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const TOGGLE_COLLECTION_EVENT = `
  mutation ToggleCollectionEvent($id: ID!, $active: Boolean!) {
    toggleCollectionEvent(id: $id, active: $active) {
      result
      errors {
        message
      }
    }
  }
`;

export const CREATE_COLLECTION_EVENT = `
  mutation CreateCollectionEvent(
    $starting: String!
    $ending: String!
    $multiplier: Float!
    $eventName: String!
    $rruleData: String
    ) {
    createCollectionEvent(
      starting: $starting
      ending: $ending
      multiplier: $multiplier
      eventName: $eventName
      rruleData: $rruleData
      ) {
        result
        errors {
          message
        }
    }
  }
`;

export const UPDATE_SMS_RECHARGE_RECURRING = `
  mutation UpdateSmsRechargeRecurring(
    $registeredNameId: ID!
    $autoRechargeThreshold: Int!
    $autoRechargeAmount: Int!
    ) {
    updateSmsRechargeRecurring(
      registeredNameId: $registeredNameId
      autoRechargeThreshold: $autoRechargeThreshold
      autoRechargeAmount: $autoRechargeAmount
      ) {
        result
        errors {
          message
        }
    }
  }
`;

export const AUTO_RECHARGE_CONFIG = `
query slBrand{
  slBrand {
    brandSmsLedger {
      smsRechargeThreshold
      smsRechargeAmount
      registeredNameId
    }
  }
}
`;

export const TOGGLE_REDEMPTION_ONLY = `
  mutation toggleRedemptionOnly {
    toggleRedemptionOnly {
      result
      errors {
        message
      }
    }
  }
`;

export const UNLINK_MAGENTO = `
mutation UnlinkMagento($code: String!) {
  unlinkMagento(code: $code) {
    result
    errors {
      message
    }
  }
}
`;

// Webhook
export const CREATE_WEBHOOK = `
  mutation createWebhook($specification: String!) {
    createWebhook(specification: $specification) {
      errors {
        message
      }
      otherEcom
      webhook {
        id
        token
      }
    }
  }
`;

// Meta
export const TOGGLE_FB_CA_UPLOAD = `
  mutation ToggleFbCaUpload {
    toggleFbCaUpload {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_FB_SETTINGS = `
  mutation UpdateFbSettings(
    $token: String!
    $accountId: String!
  ) {
    updateFbSettings(
      token: $token, 
      accountId: $accountId
    ) {
      result
      verified
      updatedAt
      errors {
        message
      }
    }
  }
`;

// Shopee
export const REGISTER_SENDINBLUE_CREDS = `
mutation RegisterSendinblueCreds(
  $creds: String!
) {
  registerSendinblueCreds(
    creds: $creds
  ) {
    result
    verified
updatedAt
    errors {
      message
    }
  }
}
`;

export const EXTERNAL_INTEGRATION = `
query ExternalIntegration($spec: String!) {
  externalIntegration(spec: $spec) {
    id
    fb {
      audienceUpload
      verified
      adminSystemUserToken
      adsAccountId
      credentialsUploadTime
      wabaVerified
      igVerified
      verifiedErr
    }
    brevo {
      audienceUpload
      verified
      accessToken
      credentialsUploadTime
    }
  }
}
`;

export const EXTERNAL_OPS_INTEGRATION = `
query ExternalIntegration($spec: String!) {
  externalIntegration(spec: $spec) {
    id
    xilnex {
      appId
      appToken
      collectionEnabled
      redemptionEnabled
      verified
      credentialsUploadTime
      outletSettings
      storeList {
        id
        name
      }
    }
    wix {
      collectionEnabled
      redemptionEnabled
      verified
      credentialsUploadTime
      webhookToken
    }
    woocommerce {
      collectionEnabled
      redemptionEnabled
      verified
      credentialsUploadTime
      webhookToken
    }
    magento {
      collectionEnabled
      redemptionEnabled
      verified
      credentialsUploadTime
      webhookToken
      prefix
      endpoint
      accessToken
    }
    shopify {
      posCollectionEnabled
      posRedemptionEnabled
      ecomCollectionEnabled
      ecomRedemptionEnabled
      verified
      credentialsUploadTime
      accessToken
      endpoint
      outletSettings
    }
    zeoniq {
      collectionEnabled
      redemptionEnabled
      verified
      token
      apiKey
      outletSettings
    }
    esb {
      collectionEnabled
      redemptionEnabled
      verified
      token
      esbStaticToken
      outletSettings
    }
    storehub {
      collectionEnabled
      redemptionEnabled
      credentials {
        id
        username
        token
        verified
        storeList {
          id
          name
        }
      }
      outletSettings
      
    }
    dinlr {
      collectionEnabled
      redemptionEnabled
      verified
      outletSettings
      state
    }
    hubbo {
      collectionEnabled
      redemptionEnabled
      verified
      outletSettings
    }
    xilnexFtp {
      collectionEnabled
      redemptionEnabled
      verified
      outletSettings
    }
    loyverse {
      collectionEnabled
      redemptionEnabled
      verified
      outletSettings
    }
    eats365 {
      collectionEnabled
      collectionMode
      redemptionEnabled
      token
      productionToken
      outletSettings
      reconnectAvailableOn
      merchantName
      contactName
      contactEmail
      contactPhone
    }
  }
}
`;

export const EATS365_INTEGRATION = `
query ExternalIntegration($spec: String!) {
  externalIntegration(spec: $spec) {
    id
    eats365 {
      collectionEnabled
      collectionMode
      redemptionEnabled
      token
      productionToken
      outletSettings
      reconnectAvailableOn
      merchantName
      contactName
      contactEmail
      contactPhone
    }
  }
}
`;

export const UPDATE_EATS365_COLLECTION_MODE = `
  mutation updateEats365CollectionMode($collectionMode: String!) {
    updateEats365CollectionMode(collectionMode: $collectionMode) {
      result
      collectionMode
      errors {
        message
      }
    }
  }
`;

export const UPDATE_EATS365_RESTAURANTS = `
  mutation updateEats365Restaurants(
    $outletId: ID!
    $restaurantCode: String
    $enabled: Boolean
  ) {
    updateEats365Restaurants(
      outletId: $outletId
      restaurantCode: $restaurantCode
      enabled: $enabled
    ) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const SEND_EATS365_CRM_REQUEST = `
  mutation sendEats365CrmRequest(
    $outlets: [Eats365OutletCodeInput!]
    $merchantName: String!
    $contactName: String!
    $contactEmail: String!
    $contactPhone: String!
  ) {
    sendEats365CrmRequest(
      outlets: $outlets
      merchantName: $merchantName
      contactName: $contactName
      contactEmail: $contactEmail
      contactPhone: $contactPhone
    ) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const UNLINK_EATS365 = `
mutation UnlinkEats365(
  $code: String!
  $merchantName: String
  $contactName: String
  $contactEmail: String
  $contactPhone: String
) {
  unlinkEats365(
    code: $code
    merchantName: $merchantName
    contactName: $contactName
    contactEmail: $contactEmail
    contactPhone: $contactPhone
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const TOGGLE_EATS365_REDEMPTION_ENABLED = `
  mutation ToggleEats365RedemptionEnabled($enabled: Boolean!) {
    toggleEats365RedemptionEnabled(enabled: $enabled) {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_EATS365_CREDENTIALS = `
  mutation UpdateEats365Credentials($token: String!) {
    updateEats365Credentials(token: $token) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const STOREHUB_INTEGRATION = `
query ExternalIntegration($spec: String!) {
  externalIntegration(spec: $spec) {
    id
    storehub {
      collectionEnabled
      redemptionEnabled
      credentials {
        id
        username
        token
        verified
        storeList {
          id
          name
        }
      }
      outletSettings
      
    }
  }
}  
`;

// Wix
export const UNLINK_WIX = `
mutation UnlinkWix($code: String!) {
  unlinkWix(code: $code) {
    result
    errors {
      message
    }
  }
}
`;

// Woocommerce
export const UNLINK_WOOCOMMERCE = `
mutation UnlinkWoocommerce($code: String!) {
  unlinkWoocommerce(code: $code) {
    result
    errors {
      message
    }
  }
}
`;

export const LOGIN_ANNOUNCEMENT = `
query LoginAnnouncement {
  loginAnnouncement {
    id
    title
    imageUrl
  }
}
`;

export const CREATE_FB_CAMPAIGN = `
mutation CreateFbCampaign(
  $title: String!
  $description: String!
  $audience: String!
  $outletIds: [ID!]
  $filterArgs: SmsScreenFilterAttributes!
) {
    createFbCampaign(
      title: $title
      description: $description
      audience: $audience
      outletIds: $outletIds
      filterArgs: $filterArgs
    ) {
      result
      errors {
        message
      }
    }
}
`;

export const FB_AUDIENCES = `
query FbAudiences($limit: Int!, $currentPage: Int!) {
  slBrand {
    id
    fbCustomAudiences(limit: $limit, currentPage: $currentPage) {
      totalRecords
      fbCustomAudience {
        customAudienceId
        specification
        name
        total
        outletId
        updatedAt
        createdAt
        campaignInfo {
          name
          approximateCount
          errors {
            message
          }
        }
      }
    }
  }
}
`;

export const ARCHIVE_FB_CAMPAIGN = `
mutation ArchiveFbCampaign(
  $id: ID!
  $archived: Boolean!
) {
    archiveFbCampaign(
      id: $id
      archived: $archived
    ) {
      result
      errors {
        message
      }
    }
}
`;

export const TOGGLE_CUSTOMER_INQUIRY = `
mutation ToggleCustomerInquiry($customerInquiry: String!){
  toggleCustomerInquiry(customerInquiry: $customerInquiry){
    result
    errors{
      message
    }
  }
}
`;

export const TOGGLE_EMAIL_MANDATORY = `
mutation ToggleEmailMandatory{
  toggleEmailMandatory{
    result
    errors{
      message
    }
  }
}
`;

export const BROADCAST_MESSAGE_REPORT = `
query BroadcastMessageReport($objectId: ID!, $specification: String!) {
  broadcastMessageReport(objectId: $objectId, specification: $specification) {
    title
    incentive
    sbsc
    startDate
    endDate
    grossProfit
    totalSpending
    smsSent
    avgReturnStr
    roas
    cpc
    cogsCost
    offerCost
    smsCost
    smsCostBillingCurrency
    membersVisitData
    membersPriorVisitData
    outletBreakdown
    currency
    dailyBreakdown
    returnees
    returneesPerc
    conversions
    conversionsPerc
    salesPerc {
      cpPerc
      cpcPerc
      roasPerc
      reachPerc
      additionalSalesPerc
    }
  }
}
`;

export const UPDATE_REFERRAL_CAMPAIGN = `
  mutation UpdateReferralCampaign(
    $id: ID!
    $startTiming: String
    $endTiming: String
    $redirectLink: String
    $referralId: String
    $smsMessage: String
    $nameholder: String
    $expiryDate: String
    $expiryDays: Int
    $redemptionLimit: Int
    $redirectLinkBtnText: String
    $testSmsSegments: Int
    $eligibleMembers: String
    $emailEnabled: Boolean
    $nameEnabled: Boolean
    $birthdayEnabled: Boolean
    $title: String
  ) {
    updateReferralCampaign(
      id: $id
      startTiming: $startTiming
      endTiming: $endTiming
      redirectLink: $redirectLink
      smsMessage: $smsMessage
      nameholder: $nameholder
      referralId: $referralId
      expiryDate: $expiryDate
      expiryDays: $expiryDays
      redemptionLimit: $redemptionLimit
      redirectLinkBtnText: $redirectLinkBtnText
      testSmsSegments: $testSmsSegments
      eligibleMembers: $eligibleMembers
      emailEnabled: $emailEnabled
      nameEnabled: $nameEnabled
      birthdayEnabled: $birthdayEnabled
      title: $title
    ) {
     result
     errors {
      message
    }
     expiryDate
   }
  }
`;

export const ALL_REFERRAL_CAMPAIGNS = `
query AllReferralCampaigns {
  slBrand {
    allReferralCampaigns {
      campaignId
      id
      imageUrl
      title
      startTiming
      endTiming
      redemptionLimit     
      roi
      expiryDate
      expiryDays
      returnees
      returnedAndSpent
      totalRedemptions
      visited
      participated
      returnRate
      smsMessage
      nameholder
      status
      redirectLink
      redirectLinkBtnText
      eligibleMembers
      emailEnabled
      nameEnabled
      birthdayEnabled
      referralId
      promotion {
        id
        title
      }
    }
  }
}
`;

export const ALL_REFERRAL_IDS = `
query AllReferralIds  {
  slBrand {
    allReferralCampaigns {
      referralId
    }
  }
}
`;

//fb ig analytics query
export const META_REPORTS = `
query MetaReports($period: Int!, $type: String!) {
  metaReports(period: $period, type: $type) {
    reportMonth
    reportYear
    additionalSales
    conversions
    totalVisits
    conversionPerc
    reach
    adBudget
  }
}
`;
export const GET_FB_GIVEAWAY_VERIFIED = `
query SlBrand {
  slBrand {
    id
    brandConfiguration {
      fbGiveawayVerified
    }
  }
}
`;

export const META_OVERVIEW = `
query MetaOverview($period: Int!) {
  metaOverview(period: $period) {
    additionalSales
    conversions
    reach
    conversionPerc
  }
}
`;

//expiry reminder
export const EXPIRY_REMINDER_CONFIG = `
query ExpiryReminderConfig($specification: String!) {
  slBrand {
    expiryReminderConfig {
      id
      frequencyEnabled
      frequencyOp
      frequencyLb
      frequencyHb
      inactiveMembersEnabled
      inactiveMembersOp
      inactiveMembersLb
      inactiveMembersHb
      lifetimeValueEnabled
      lifetimeValueOp
      lifetimeValueLb
      lifetimeValueHb
      smsMessage
      nameholder
      displayPromo(specification: $specification)
      activeStampConfigurations {
        status
        expiryDays
      }
      foreignMessageEnabled
    }
  }
}
`;

export const TOGGLE_EXPIRY_REMINDER_OPTIONS = `
mutation ToggleExpiryReminderOptions($option: String!, $enabled: Boolean!) {
  toggleExpiryReminderOptions(option: $option, enabled: $enabled) {
    result
    errors {
      message
    }
  }
}
`;

export const ARCHIVE_FB_OFFLINE = `
mutation ArchiveFbOffline(
  $id: ID!
  $archived: Boolean!
) {
  archiveFbOffline(
    id: $id
    archived: $archived
  ) {
    result 
    errors {
      message
    }
  }
}
`;

export const ACTIVITY_LOG = `
query ActivityLogs($first: Int, $after: String, $targetQuery: [String!], $operationQuery: [String!]) {
  activityLogs(first: $first, after: $after, targetQuery: $targetQuery, operationQuery: $operationQuery) {
    edges {
      node {
        id
        user {
          id
          name
        }
        brand {
          id
        }
        operation
        appEnv
        target
        operationName
        metadata
        activityText
        createdAt
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
`;

export const GET_REVIEW_SMS_TEMPLATE = `
query ReviewSmsTemplate {
  reviewSmsTemplate {
    reviewSuccessMsg
    reviewErrorMsg
  }
}
`;

export const CREATE_REVIEW_CAMPAIGN = `
mutation CreateReviewCampaign (
  $reviewId: String!
  $enabledOutletIds: [ID!]!
  $title: String!
  $promotionType: String!
  $promotionCost: Float!
  $startDate: String!
  $endDate: String
  $redemptionLimit: Int
  $expiry: Int!
  $minSpendEnabled: Boolean!
  $minSpend: Int
  $defaultHashtags: [String!]
  $customHashtags: [String!]
  $promotionName: String
  $discountLimit: Int
  $posIntegration: String
  $ecomIntegration: String
  $shopifyProductId: String
  $rebateCost: Float
  $esbItemCode: String
  $eats365ProductCode: String
  $reviewType: String!
  $requireHashtag: Boolean!
  $smsMessage: String
  $errorMessage: String
) {
  createReviewCampaign(
    reviewId: $reviewId
    enabledOutletIds: $enabledOutletIds
    title: $title
    promotionType: $promotionType
    promotionCost: $promotionCost
    startDate: $startDate
    endDate: $endDate
    redemptionLimit: $redemptionLimit
    expiry: $expiry
    minSpendEnabled: $minSpendEnabled
    minSpend: $minSpend
    defaultHashtags: $defaultHashtags
    customHashtags: $customHashtags
    promotionName: $promotionName
    discountLimit: $discountLimit
    posIntegration: $posIntegration
    ecomIntegration: $ecomIntegration
    shopifyProductId: $shopifyProductId
    rebateCost: $rebateCost
    esbItemCode: $esbItemCode
    eats365ProductCode: $eats365ProductCode
    reviewType: $reviewType
    requireHashtag: $requireHashtag
    smsMessage: $smsMessage
    errorMessage: $errorMessage
  ) {
    result
    integrationItemCode
    errors {
      message
    }
    campaignId
  }
}
`;

export const BRAND_TOTAL_REVIEW_CAMPAIGNS = `
query BrandTotalReviewCampaigns {
  slBrand {
    totalReviewCampaigns
  }
}
`;

export const ACTIVE_REVIEW_OUTLETS = `
  query ActiveReviewOutlets($outletIds: [ID!]!) {
    activeReviewOutlets(outletIds: $outletIds) {
      outletId
      campaignTitle
    }
  }
`;

export const REVIEW_CAMPAIGN_HISTORY = `
  query ReviewCampaigns(
    $limit: Int!
    $currentPage: Int!
    $sort: String!
    $direction: String!
    $filters: [String!]
    ) {
    reviewCampaigns(
      limit: $limit
      currentPage: $currentPage
      sort: $sort
      direction: $direction
      filters: $filters
    ) {
      totalRecords
      records {
        organizerId
        campaignId
        reviewId
        reviewType
        requireHashtag
        title
        status
        promoId
        promotionName
        promotionCost
        promotionType
        createdAt
        startTiming
        endTiming
        minSpend
        minSpendEnabled
        linkedOutlets {
          id
          name
          placeId
          address
          initialRating
          currentRating
          initialReviews
          currentReviews
        }
        totalReviews
        totalOutlets
        redemptionLimit
        expiry
        additionalSales
        defaultHashtags
        customHashtags
        imageData
        totalVisits
        redemptions
        smsMessage
        errorMessage
      }
    }
  }
`;

export const UPDATE_REVIEW_CAMPAIGN = `
  mutation UpdateReviewCampaign(
    $organizerId: ID!
    $endDate: String
    $redemptionLimit: Int
    $enabledOutletIds: [ID!]
    $expiry: Int
    $minSpend: Int
    $defaultHashtags: [String!]
    $customHashtags: [String!]
    $smsMessage: String
    $errorMessage: String
  ) {
    updateReviewCampaign(
      organizerId: $organizerId
      endDate: $endDate
      redemptionLimit: $redemptionLimit
      enabledOutletIds: $enabledOutletIds
      expiry: $expiry
      minSpend: $minSpend
      defaultHashtags: $defaultHashtags
      customHashtags: $customHashtags
      smsMessage: $smsMessage
      errorMessage: $errorMessage
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const CREATE_GIVEAWAY = `
mutation CreateGiveaway(
  $giveawayArgs: CreateGiveawayGiveawayAttributes!,
  $campaignArgs: CreateGiveawayCampaignAttributes!,
  $promotionArgs: CreateGiveawayPromotionAttributes!
  ) {
    createGiveaway(
      giveawayArgs: $giveawayArgs
      campaignArgs: $campaignArgs
      promotionArgs: $promotionArgs
    ) {
      result
      organizerId
      errors {
        message
      }
    }
  }`;

export const CREATE_EXPIRY_REMINDER_OPTION = `
mutation CreateExpiryReminderOption(
  $options: ExpiryReminderOptionsInput!
) {
  createExpiryReminderOption(options: $options) {
    result
    errors {
      message
    }
  }
}
`;

export const DELETE_EXPIRY_REMINDER_OPTION = `
mutation DeleteExpiryReminderOption(
  $key: String!
) {
  deleteExpiryReminderOption(key: $key) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_EXPIRY_REMINDER_ADVANCED = `
mutation UpdateExpiryReminderAdvanced(
  $smsMessage: String!
  $nameholder: String
) {
  updateExpiryReminderAdvanced(
    smsMessage: $smsMessage
    nameholder: $nameholder
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const MEMBERSHIP = `
query SlMembership {
  membership {
    detailId
    timeLimit
    foreignMessageEnabled
    membershipTiers {
      id
      threshold
      name
      color
      notifyNewMembers
      rank
      smsMessage
      nameholder
    }
    membershipBenefits {
      id
      name
      specification
      benefitType
      category
      filtrationMode
      smsMessage
      expiryDays
      nameholder
      tierValues {
        tierName
        value
      }
    }
  }
}
`;

export const UPDATE_MEMBERSHIP = `
mutation UpdateMembership(
  $timeLimit: Int!
) {
  updateMembership(
    timeLimit: $timeLimit
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const CREATE_MEMBERSHIP_BENEFIT = `
mutation CreateMembershipBenefit(
  $detailId: ID!
  $name: String!
  $specification: String!
  $category: String!
  $benefitType: String!
  $monetaryCost: Float!
  $filtrationMode: String!
  $smsMessage: String!
  $expiryDays: Int!
  $discountLimit: Int
  $posIntegration: String
  $ecomIntegration: String
  $shopifyProductId: String
  $nameholder: String!
  $rebateCost: Float
  $esbItemCode: String
  $eats365ProductCode: String
  $testSmsSegments: Int!
) {
  createMembershipBenefit(
    detailId: $detailId
    name: $name
    specification: $specification
    category: $category
    benefitType: $benefitType
    monetaryCost: $monetaryCost
    filtrationMode: $filtrationMode
    smsMessage: $smsMessage
    expiryDays: $expiryDays
    discountLimit: $discountLimit
    posIntegration: $posIntegration
    ecomIntegration: $ecomIntegration
    shopifyProductId: $shopifyProductId
    nameholder: $nameholder
    rebateCost: $rebateCost
    esbItemCode: $esbItemCode
    eats365ProductCode: $eats365ProductCode
    testSmsSegments: $testSmsSegments
  ) {
    result
    integrationItemCode
    errors {
      message
    }
  }
}
`;

export const UPDATE_MEMBERSHIP_BENEFIT = `
mutation UpdateMembershipBenefit(
  $id: ID!
  $tierName: String!
  $tierValue: String!
) {
  updateMembershipBenefit(
    id: $id
    tierName: $tierName
    tierValue: $tierValue
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_MEMBERSHIP_BENEFIT_SMS_MESSAGE = `
mutation UpdateMembershipBenefitSmsMessage(
  $id: ID!
  $smsMessage: String!
  $expiryDays: Int!
  $nameholder: String!
  $testSmsSegments: Int
) {
  updateMembershipBenefitSmsMessage(
    id: $id
    smsMessage: $smsMessage
    expiryDays: $expiryDays
    nameholder: $nameholder
    testSmsSegments: $testSmsSegments
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const DELETE_MEMBERSHIP_BENEFIT = `
mutation DeleteMembershipBenefit(
$id: ID!
) {
  deleteMembershipBenefit(
    id: $id
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const CREATE_MEMBERSHIP_TIER = `
mutation CreateMembershipTier(
  $detailId: ID!
  $title: String!
  $threshold: Int!
  $color: String!
) {
  createMembershipTier(
    detailId: $detailId
    title: $title
    threshold: $threshold
    color: $color
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_MEMBERSHIP_TIER = `
mutation UpdateMembershipTier(
  $id: ID!
  $title: String
  $threshold: Int
  $default: Boolean
  $color: String
  $notifyNewMembers: Boolean
  $newMemberMsg: String
  $nameholder: String
  $testSmsSegments: Int
) {
  updateMembershipTier(
    id: $id
    title: $title
    threshold: $threshold
    default: $default
    color: $color
    notifyNewMembers: $notifyNewMembers
    newMemberMsg: $newMemberMsg
    nameholder: $nameholder
    testSmsSegments: $testSmsSegments
  ) {
    result 
    errors {
      message
    }
  }
}
`;

export const DELETE_MEMBERSHIP_TIER = `
mutation DeleteMembershipTier(
  $id: ID!
  $detailId: ID!
) {
  deleteMembershipTier(
    id: $id
    detailId: $detailId
  ) {
    result
    errors {
      message
    }
  }
} 
`;

export const ENABLE_MEMBERSHIP = `
mutation EnableMembership(
  $spend: Float
  $spendType: String
) {
  enableMembership(
    spend: $spend
    spendType: $spendType
  )  {
    result
    errors {
      message
    }
  }
}
`;

export const ENABLE_EXPIRY_REMINDERS = `
mutation EnableExpiryReminders {
  enableExpiryReminders {
    result
    errors {
      message
    }
  }
}
`;

export const OVERALL_SPENDING = `
query OverallSpending {
  slBrand {
    overallSpending
    specification
  }
}
`;

export const DEMOTED_MEMBERS = `
query DemotedMembersOnDelete (
  $tierId: ID!
) {
    demotedMembersOnDelete (
      tierId: $tierId
    ) 
  } 
}
`;

export const FB_INSTA = `
query FbInsta {
  fbInsta {
    id
    username
    mediaCount
    followersCount
    mediaInfo
    storyInfo
    insightInfo
    commentsInfo
    replyableInfo
  }
}
`;

export const FB_INSTA_REPLY = `
mutation FbInstaReply(
  $commentId: ID!
  $message: String!
) {
  replyToInstaComment(
    commentId: $commentId
    message: $message
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const CREATE_WS_TEMPLATE = `
mutation CreateWsTemplate(
  $textHeaderArgs: WsTemplateTextHeaderArgs
  $mediaHeaderArgs: WsTemplateMediaHeaderArgs
  $message: String!
  $buttonArgs: [WsTemplateButtonArgs!]
  $footer: String
  $name: String!
  $languageCode: String!
  $fbWsAccountId: ID!
  $specification: String!
) {
  createWsTemplate(
    textHeaderArgs: $textHeaderArgs
    mediaHeaderArgs: $mediaHeaderArgs
    message: $message
    buttonArgs: $buttonArgs
    footer: $footer
    name: $name
    languageCode: $languageCode
    fbWsAccountId: $fbWsAccountId
    specification: $specification
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const WS_TEMPLATES = `
query WsTemplates(
   $filters: WsTemplateSearch
   $limit: Int
   $currentPage: Int!
) {
  fbWsTemplates(
    filters: $filters
    limit: $limit
    currentPage: $currentPage
    
  ) {
    id
    name
    status
    fbTemplateId
    languageCode
    updatedAt
    overallCount
    bodyContent
    wabaName
    deletable
    specification
    lastTested
    testedRecently
  }
}
`;

export const WS_TEMPLATE = `
query WsTemplate($fbTemplateId: ID!) {
  fbWsTemplate(fbTemplateId: $fbTemplateId)
}
`;

export const SEND_TEST_WS = `
mutation SendTestWs(
  $templateId: ID!
  $phoneNumber: String!
  $extension: String!
) {
  sendTestWs(
    templateId: $templateId
    phoneNumber: $phoneNumber
    extension: $extension
  ) {
    result
    sentCount
    errors {
      message
    }
  }
}
`;

export const DELETE_WS_TEMPLATE = `
mutation DeleteWsTemplate(
  $id: ID!
) {
  deleteWsTemplate(
    id: $id
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const WABA_LINKED = `
  subscription {
    wabaLinked {
      status
      message
    }
  }
`;

export const BRAND_CREDIT_UPDATED = `
  subscription {
    brandCreditUpdated {
      brandId
      availableCredits
    }
  }
`;

export const GIVEAWAYS_HISTORY = `
query GiveawaysHistory($limit: Int!, $currentPage: Int!) {
  slBrand {
    id
    giveawayHistory(limit: $limit, currentPage: $currentPage) {
      totalRecords
      giveaways {
        id
        startTiming
        endTiming
        spendingThreshold
        friendTagThreshold
        shareTagPost
        rewardImageUrl
        conversions
        status
        additionalSales
        completedTasks
        totalRedemptions
        campaign {
          id
          title
          messageExpiryDays
          smsMessage
          nameholder
        }
        promotion {
          id
          title
          monetaryCost
        }
      }
    }
  }
}
`;

export const INSTA_BUSINESS_INFO = `
query InstaBusinessInfo {
  slBrand {
    id
    instaBusinessInfo {
      id
      username
      profilePictureUrl
    }
  }
}
`;

export const INSTA_USER_MEDIAS = `
query InstaUserMedias {
  slBrand {
    id
    instaBusinessMedias {
      id
      shortcode
      mediaUrl
      caption
      createdAt
    }
  }
}
`;
export const RATE_CHARGES = `
  query RateCharges {
    rateCharges {
      amount
      description
      smsRate
      whatsappRate
      emailRate
    }
  }
`;

export const CREATE_POST_LOGIN_ANALYTICS = `
mutation CreatePostLoginAnalytics (
  $date: String!
  $duration: Int!
  $action: String!
  $templateId: ID!
) {
  createPostLoginAnalytics (
    date: $date
    duration: $duration
    action: $action
    templateId: $templateId
  ) {
    result 
    errors {
      message
    }
  }
}
`;

export const CHANCE_DEFAULTS_QUERY = `
query ChanceDefaults {
  chanceDefaults {
    medianSpend
    chanceRecommendationResults{
      value
      probability
      promotionType
      prizeNameText
    }
    chanceIncentiveExpiry
  }
}
`;

export const CREATE_CHANCE_CAMPAIGN = `
 mutation CreateChanceCampaign($campaignInfo: ChanceCampaignInput!, $promotionInfo: [ChancePromotionInput!]!) {
      createChanceCampaign(campaignInfo: $campaignInfo, promotionInfo: $promotionInfo) {
      result
      integrationItemCodes {
        promotionType
        promotionName
        integrationItemCode
      }
      errors {
        message
      }
    }
  }
`;

// Spin and Win History
export const CHANCE_CAMPAIGNS = `
query chanceCampaigns($limit: Int!, $currentPage: Int!, $sort: String!, $direction: String!, $filterStatus: [String!]) {
    chanceCampaigns(limit: $limit, currentPage: $currentPage, sort: $sort, direction: $direction, filterStatus: $filterStatus) {
      totalRecords
      records {
        title
        campaignId
        campaignType
        outletIds
        status
        startDate
        endDate
        smsMessage
        minSpend
        expiry
        prizes {
          id
          name
          promotion {
            promotionType
            monetaryCost
            discountLimit
            rebateCost
            shopifyProductId
            eats365ProductCode
            ecomSettings{
              name
              enabled
            }
            posSettings{
              name
              enabled
            }
          }
          probability
          won
          redeemed
          verifiedRedemptions
        }
        additionalSales
        averageLift
        medianSpend
        transactionsQualified
        spins
        spinsWon
        redeemed
      }
    }
  }
`;

export const TOGGLE_CHANCE_CAMPAIGN_STATUS = `
mutation ToggleChanceCampaignStatus(
  $campaignId: ID!
) {
  toggleChanceCampaignStatus(
    campaignId: $campaignId
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_CHANCE_CAMPAIGN = `
mutation UpdateChanceCampaign(
  $campaignId: ID!
  $title: String
  $endDate: String
  $minSpend: Int
  $expiry: Int
) {
  updateChanceCampaign(
    campaignId: $campaignId
    title: $title
    endDate: $endDate
    minSpend: $minSpend
    expiry: $expiry
  ) {
    result
    errors {
      message
    }
  }
}
`;
export const TOGGLE_OUTLET_ACTIVE = `
mutation ToggleOutletActive (
  $outletId: ID!
) {
  toggleOutletActive(
    outletId: $outletId
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_CHANCE_PRIZE = `
  mutation UpdateChancePrize(
    $id: ID!
    $type: String!
    $name: String!
    $value: Int!
    $probability: Float!
  ) {
    updateChancePrize(
      id: $id
      type: $type
      name: $name
      value: $value
      probability: $probability
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_CHANCE_PRIZES = `
  mutation UpdateChancePrizes(
    $campaignId: ID!
    $prizes: [ChancePromotionInput!]!
  ) {
    updateChancePrizes(
      campaignId: $campaignId
      prizes: $prizes
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const POST_LOGIN_ANNOUNCEMENT = `
query PostLoginAnnouncement {
  postLoginAnnouncement {
    activated
    postLoginTemplates {
      id
      announcementStartDate
      headline
      description
      content {
        title
        description
        enabled
        hyperlinkText
        hyperlinkUrl
      }
      mainButtonName
      mainButtonUrl
      secondaryButtonName
      secondaryButtonUrl
      urlToggle
      imageUrl
      descriptionLinkUrl
      descriptionLinkText
      enabledClose
      seen
    }
  }
}
`;

export const MESSAGE_COUNT = `
query MessageCount($amount: Float!) {
  messageCount(amount: $amount) {
    smsCount
    whatsappCount
    emailCount
    waCostPrice
    paymentToWa
    paymentToSl
    paymentTotal
  }
}
`;

export const MEMBERS_PORTAL_DATA = gql`
  query MembersPortal {
    slBrand {
      id
      membershipType
      membershipDetails {
        detailId
        membershipTiers {
          id
          name
          color
          rank
        }
      }
      brandPortalSetting {
        id
        colorPalette
        logoUrl
        logoUrl
        showCoverPhoto
        coverSpecification
        coverPhotoDuration
        coverColor
        coverPhotoUrl
        carouselTitle
        carouselSpecification
        carouselSpacesCustom {
          id
          index
          enabled
          caption
          description
          urlActive
          url
          imageUrl
        }
        carouselSpacesInsta {
          index
          enabled
          id
          caption
          description
          url
          imageUrl
        }
        links {
          id
          index
          title
          enabled
          url
          emoji
        }
        lbSpecification
        lbColor
        lbGradient
        lbColorSpecification
        lbPhotoUrl
        lbOpacity
        topNavbarSpecification
        topNavbarColor
        topNavbarGradient
        topNavbarColorSpecification
        topNavbarPhotoUrl
        topNavbarOpacity
        topNavbarTextColor
        membersInfoSpecification
        membersInfoColor
        membersInfoTextColor
        membersInfoGradient
        membersInfoColorSpecification
        membersInfoPhotoUrl
        membersInfoOpacity
        generalBackgroundColor
        generalBackgroundGradient
        generalBackgroundColorSpecification
        headerTextColor
        primaryTextColor
        secondaryTextColor
        textLinkColor
        botNavbarBackgroundColor
        botNavbarDefaultColor
        botNavbarSelectedColor
        primaryBtnColor
        primaryBtnTextColor
        primaryBtnBorderColor
        secondaryBtnColor
        secondaryBtnTextColor
        secondaryBtnBorderColor
        storeListCardColor
        storeListCardTextColor
        linkColor
        linkTextColor
        linkBorderColor
        privilegeBannerColor
        privilegeBannerTextColor
        privilegeBannerIconColor
        privilegeBannerIconBg
        showAddToHome
        showWallet
        appIconUrl {
          icon512
          icon192
        }
        appDisplayName
        mainStampConfiguration {
          id
          version
          stampsToComplete
          status
          description
          textColor
          iconUrl
          iconImg
          cardColorSpecification
          cardBackgroundColor
          stampBackgroundColor
          footer
          frontCardImageUrl
          expiryDays
          rewardIconImg
          rewardImageUrl
          rewardBackgroundColor
          rewardTextColor
          cardsIssued
          totalMembers
          redeemed
          promotion {
            promotionType
            title
            monetaryCost
          }
          stpc {
            id
            modifier
            threshold
            specification
          }
        }
        template
        gridSize
        gridButtons {
          index
          active
          label
          iconSpecification
          iconUrl
          iconColor
          redirectSpecification
          redirectUrl
        }
        font {
          headerFontFamily
          headerFontSettings
          primaryFontFamily
          primaryFontSettings
          secondaryFontFamily
          secondaryFontSettings
          textLinkFontFamily
          textLinkFontSettings
          topNavbarFontFamily
          topNavbarFontSettings
          membersInfoFontFamily
          membersInfoFontSettings
          bottomNavbarDefaultFontFamily
          bottomNavbarDefaultFontSettings
          bottomNavbarSelectedFontFamily
          bottomNavbarSelectedFontSettings
          primaryBtnFontFamily
          primaryBtnFontSettings
          secondaryBtnFontFamily
          secondaryBtnFontSettings
          linksBtnFontFamily
          linksBtnFontSettings
          storeListCardFontFamily
          storeListCardFontSettings
          privilegeBannerFontFamily
          privilegeBannerFontSettings
        }
      }
      groupPortalSetting {
        backgroundColor
        textColor
        selectedBackgroundColor
        selectedTextColor
      }
    }
  }
`;

export const MEMBERS_PORTAL_BRAND_LOGO = `
query MembersPortal {
  slBrand{
    brandPortalSetting {
      logoUrl
    }
  }
}
`;

export const UPDATE_MEMBERS_PORTAL_SETTINGS = `
mutation UpdateMembersPortalSettings(
  $colorPalette: [String!]
  $coverPhoto: PortalSpecificationInput!
  $carouselTitle: String!
  $carouselSpecification: String!
  $carouselSpacesCustom: [CarouselSpacesInput!]
  $carouselSpacesInsta: [CarouselSpacesInput!]
  $links: [LinksInput!]!
  $landscapeBackground: PortalSpecificationInput!
  $membersInfo: TopNavbarInput!
  $topNavbar: TopNavbarInput!
  $colors: PortalColorsInput!
  $template: String!
  $gridSize: Int
  $gridButtons: [PortalGridButtonInput!]
  $headerFontSettings: FontSettingsInput!
  $primaryFontSettings: FontSettingsInput!
  $secondaryFontSettings: FontSettingsInput!
  $textLinkFontSettings: FontSettingsInput!
  $topNavbarFontSettings: FontSettingsInput!
  $membersInfoFontSettings: FontSettingsInput!
  $bottomNavbarDefaultFontSettings: FontSettingsInput!
  $bottomNavbarSelectedFontSettings: FontSettingsInput!
  $primaryBtnFontSettings: FontSettingsInput!
  $secondaryBtnFontSettings: FontSettingsInput!
  $linksBtnFontSettings: FontSettingsInput!
  $storeListCardFontSettings: FontSettingsInput!
  $privilegeBannerFontSettings: FontSettingsInput
) {
  updateMembersPortalSettings(
    colorPalette: $colorPalette
    coverPhoto: $coverPhoto
    carouselTitle: $carouselTitle
    carouselSpecification: $carouselSpecification
    carouselSpacesCustom: $carouselSpacesCustom
    carouselSpacesInsta: $carouselSpacesInsta
    links: $links
    landscapeBackground: $landscapeBackground
    membersInfo: $membersInfo
    topNavbar: $topNavbar
    colors: $colors
    template: $template
    gridSize: $gridSize
    gridButtons: $gridButtons
    headerFontSettings: $headerFontSettings
    primaryFontSettings: $primaryFontSettings
    secondaryFontSettings: $secondaryFontSettings
    textLinkFontSettings: $textLinkFontSettings
    topNavbarFontSettings: $topNavbarFontSettings
    membersInfoFontSettings: $membersInfoFontSettings
    bottomNavbarDefaultFontSettings: $bottomNavbarDefaultFontSettings
    bottomNavbarSelectedFontSettings: $bottomNavbarSelectedFontSettings
    primaryBtnFontSettings: $primaryBtnFontSettings
    secondaryBtnFontSettings: $secondaryBtnFontSettings
    linksBtnFontSettings: $linksBtnFontSettings
    storeListCardFontSettings: $storeListCardFontSettings
    privilegeBannerFontSettings: $privilegeBannerFontSettings
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_SHOW_ADD_TO_HOME = `
mutation UpdateShowAddToHome(
  $showAddToHome: Boolean!
) {
  updateShowAddToHome(
    showAddToHome: $showAddToHome
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_PWA_APP_CONFIG = `
  mutation UpdatePwaAppConfig($appDisplayName: String) {
    updatePwaAppConfig(appDisplayName: $appDisplayName) {
      result
      errors {
        message
      }
    }
  }
`;

export const GENERATE_DISABLE_MEMBERSHIP_CODE = `
  mutation GenerateDisableMembershipCode {
    generateDisableMembershipCode {
      result
      errors {
        message
      }
    }
  }
`;

export const VALIDATE_DISABLE_MEMBERSHIP_CODE = `
 mutation ValidateDisableMembershipCode (
  $code: String!
 ) {
  validateDisableMembershipCode (
    code: $code
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const DASHBOARD_TOOLTIPS = `
  query DashboardTooltips($location: String) {
    dashboardTooltips(location: $location) {
      id
      location
      language
      title
      content
      identifier
    }
  }
`;

export const BRAND_SMS_MEMBERS = `
query BrandSmsMembers($forBroadcast: Boolean, $channel: String) {
  slBrand {
    id
    groupedMembers(forBroadcast: $forBroadcast, channel: $channel)
  }
}
`;

export const BRAND_MEMBERSHIPS = `
query BrandMemberships {
  slBrand {
    id
    memberships {
      id
      title
    }
  }
}
`;

export const CURRENT_MESSAGE_COUNT = `
query CurrentMessageCount($amount: Float!) {
  currentMessageCount(amount: $amount) {
    smsCount
    whatsappCount
    emailCount
    }
  }
`;

export const PROCESS_PAYMENT_SETUP = `
  mutation ProcessPaymentSetup($sessionId: String!) {
    processPaymentSetup(sessionId: $sessionId) {
      result
      errors {
        message
      }
    }
  }
`;

export const BRAND_CREDIT_USAGE = `
query BrandCreditUsage (
  $month: String!
  $year: String!
) {
  brandCreditUsage (
    month: $month
    year :$year
  ) {
    creditsUsed
    smsSent
    whatsappSent
    updatedAt
  }
}
`;

export const OUTLET_CREDIT_USAGE = `
query OutletCreditUsage (
  $month: String!
  $year: String!
) {
  outletCreditUsage (
    month: $month
    year: $year
  ) {
    outletName
    month
    year
    totalCredits
    smsCredits
    whatsappCredits
  }
}
`;

export const OUTLET_MESSAGE_SENT = `
query OutletMessageSent (
  $month: String!
  $year: String!
) {
  outletCreditUsage (
    month: $month
    year: $year
  ) { 
    outletName
    month
    year
    messagesSent
    smsSent
    whatsappSent
  }
}
`;

export const OUTLET_CREDIT_USAGE_SUM = `
query OutletCreditUsageSum (
  $period: Int!
  $outletId: ID
) {
  outletCreditUsageSum (
    period: $period
    outletId: $outletId
  ) {
    month
    year
    monthlyCredits
    smsCredits
    whatsappCredits
  }
}
`;

export const OUTLET_MESSAGE_USAGE_SUM = `
query OutletMessageUsageSum (
  $period: Int!
  $outletId: ID
) {
  outletCreditUsageSum (
    period: $period
    outletId: $outletId
  ) {
    month
    year
    messagesSent
    smsSent
    whatsappSent
  }
}
`;

export const OUTLET_CREDIT_USAGE_BREAKDOWN = `
query OutletCreditUsageBreakdown (
  $year: String
) {
  outletCreditUsageBreakdown (
    year: $year
  ) {
    month
    year
    monthlyCredits
    messagesSent
    automationCredits
    broadcastCredits
    verificationCredits
    eventCredits
  }
  }
`;

export const UPDATE_USER_INFO_NAME = `
 mutation UpdateUserInfoName (
  $name: String!
 ) {
  updateUserInfoName (
    name: $name
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const UPDATE_USER_INFO_PHONE = `
 mutation UpdateUserInfoPhone (
  $token: String!
  $phoneNumber: String!
  $extension: String!
 ) {
  validateUpdateUserInfoPhoneNumber (
    token: $token
    phoneNumber: $phoneNumber
    extension: $extension
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const GENERATE_UPDATE_USER_INFO_CODE = `
 mutation GenerateUpdateUserInfoCode (
  $specification: ID!
  $newEmail: String
 ) {
  generateUpdateUserInfoCode (
    specification: $specification
    newEmail: $newEmail
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const GENERATE_UPDATE_USER_INFO_PHONE_CODE = `
  mutation GenerateUpdateUserInfoPhoneCode($phoneNumber: String!, $extension: String!) {
    generateUpdateUserInfoPhoneCode(phoneNumber: $phoneNumber, extension: $extension) {
      result
      errors {
        message
      }
    }
  }
`;

export const VALIDATE_UPDATE_USER_INFO_PW = `
 mutation ValidateUpdateUserInfoPw (
  $token: String!
  $password: String!
  $passwordConfirmation: String!

 ) {
  validateUpdateUserInfoPw (
    token: $token
    password: $password
    passwordConfirmation: $passwordConfirmation

  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const VALIDATE_UPDATE_USER_INFO_EMAIL = `
 mutation ValidateUpdateUserInfoEmail (
  $token: String!
  $email: String!

 ) {
  validateUpdateUserInfoEmail (
    token: $token
    email: $email

  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const VALIDATE_UPDATE_USER_INFO_CODE = `
 mutation ValidateUpdateUserInfoCode (
  $specification: String!
  $code: String!
 ) {
  validateUpdateUserInfoCode (
    specification: $specification
    code: $code
  ) {
    result
    errors {
      message
    }
  }
 }
`;

export const DELETE_BRAND_LOGO = `
mutation DeleteBrandLogo {
  deleteBrandLogo {
    result
    errors {
      message
    }
  }
 }
`;

export const AUTOMATION_HISTORY = `
  query AutomationHistory(
    $currentPage: Int!
    $sort: String!
    $direction: String!
    $limit: Int!
    $startMonth: Int
    $startYear: Int
    $endMonth: Int
    $endYear: Int
  ) {
    automationHistory(
      currentPage: $currentPage
      sort: $sort
      direction: $direction 
      limit: $limit
      startMonth: $startMonth
      startYear: $startYear
      endMonth: $endMonth
      endYear: $endYear
    ) {
      totalRecords
      records {
        id
        messageType
        archived
        messageExpiryDays
        createdAt
        smsMessage
        specification
        specificationNumber
        promotionTitle
        ongoing
        additionalSales
        messagesSent
        messagesDelivered
        messagesError
        messagesExpired
        messagesRedeemed
        conversions
        returnedAndSpent
      }
    }
  }
`;

export const CANCEL_ANNOUNCEMENT_BROADCASTS = `
  mutation CancelAnnouncementBroadcast($id: ID!) {
    cancelAnnouncementBroadcast(id: $id) {
      result
      errors {
        message
      }
    }
  }
  `;

export const CANCEL_MANUAL_BROADCASTS = `
  mutation CancelManualBroadcast($id: ID!) {
    cancelManualBroadcast(id: $id) {
      result
      errors {
        message
      }
    }
  }
  `;

export const SL_PLAN_NOTIFICATION_CONFIG = `
query SlPlanNotificationConfigs {
    slPlanNotificationConfigs {
      id
      specification
      bubbleTitle
      bubbleBody
      popupTitle
      popupSubtitle
      popupBody
    }
  }
`;

export const CREATE_TRIAL_SUBSCRIPTION = `
mutation CreateTrialSubscription(
  $registeredNameId: ID!
  $currentPage: String!
) {
  createTrialSubscription(
    registeredNameId: $registeredNameId
    currentPage: $currentPage
  ) {
    result
    url
    errors {
      message
    }
  }
}
`;

export const QUEUED_VOUCHERS = `
  query QueuedVouchers($currentPage: Int!, $limit: Int!, $filters: QueuedVoucherSearch) {
    queuedVouchers(currentPage: $currentPage, limit: $limit, filters: $filters) {
     totalRecords
      records {
        voucherId
        customerId
        createdAt
        specification
        smsMessage
        deliveryType
        voucherType
        transient
        incentiveName
        memberName
        expiryDate
      }
    }
  }
`;

export const RESEND_QUEUED_VOUCHER = `
  mutation ResendQueuedVouchers($vouchers: [ResendVouchersInput!]!) {
    resendQueuedVouchers(vouchers: $vouchers) {
      result 
      errors {
        message
      }
      countSent
    }
  }
`;

export const RESEND_ALL_QUEUED_VOUCHER = `
  mutation ResendAllQueuedVouchers {
    resendAllQueuedVouchers {
      result 
      errors {
        message
      }
      countSent
    }
  }
`;

export const CREATE_PAID_SUBSCRIPTION = `
mutation CreatePaidSubscription(
  $registeredNameId: ID!
  $currentPage: String!
) {
  createPaidSubscription(
    registeredNameId: $registeredNameId
    currentPage: $currentPage
  ) {
    result
    url
    errors {
      message
    }
  }
}
`;

export const CANCEL_SUBSCRIPTION = `
mutation CancelSubscription{
  cancelSubscription 
  {
    result
    errors {
      message
    }
  }
}
`;

export const OUTLET_PRICES = `
query SlBrand {
  slBrand {
    perOutletRate(plan: "Business")
    basicPerOutletRate: perOutletRate(plan: "Basic")
  }
}
`;

export const ACTIVE_OUTLETS = `
query SlBrand {
  slBrand {
    activeOutlets{
      id
      name
    }
  }
}
`;

export const DASHBOARD_OVERVIEW_INFO = `
query DashboardOverviewInfo{
  slBrand {
    id
    overallUsers
    monthlyAdditionalSales
    monthlyOverallUsersRecord
    yearlyAdditionalSales
    returnRate
  }
}
`;

export const DASHBOARD_MEMBER_STATISTIC = `
query DashboardMemberStatistic{
  slBrand {
    overallUsers
    monthlyOverallUsersRecord
  }
}
`;

export const DASHBOARD_MONTHLY_ADDITIONAL_SALES = `
query DashboardMonthlyAdditionalSales{
  slBrand {
    monthlyAdditionalSalesOverview
  }
}
`;

export const GOOGLE_REVIEW_RATING = `
  query GoogleReviewRating($outletId: ID, $startDate: String, $endDate: String) {
    googleReviewRating(outletId: $outletId, startDate: $startDate, endDate: $endDate) {
      rating
      reviews
      oneStar
      twoStar
      threeStar
      fourStar
      fiveStar
    }
  }
`;

export const GOOGLE_REVIEW_BY_STORE = `
  query GoogleReviewByStore($startDate: String, $endDate: String) {
    googleReviewByStore(startDate: $startDate, endDate: $endDate) {
      outletId
      name
      googleRating
      totalGoogleReviews
    }
  }
`;

export const GET_GOOGLE_REVIEWS = `
  query GetGoogleReviews($currentPage: Int!, $limit: Int!, $outletId: ID, $rating: Int, $sort: [String!], $direction: [String!], $startDate: String, $endDate: String) {
    googleReviews(currentPage: $currentPage, limit: $limit, outletId: $outletId, rating: $rating, sort: $sort, direction: $direction, startDate: $startDate, endDate: $endDate) {
      totalRecords
      records {
        id
        outletId
        outletName
        name
        reviewTime
        content
        rating
        reviewUrl
        imageUrls
      }
    }
  }
`;

export const CUSTOMER_RATING_TRENDS = `
  query CustomerRatingTrends($period: Int!, $outletId: ID) {
    customerRatingTrends(period: $period, outletId: $outletId) {
      month
      year
      oneStar
      twoStar
      threeStar
      fourStar
      fiveStar
    }
  }
`;

export const GET_REVIEW_LINKED_STORES = `
  query GetReviewLinkedStores {
    reviewLinkedStores {
      linked {
        id
        name
        placeId
        address
        scrapeReviews
      }
      notLinked {
        id
        name
        placeId
        address
        scrapeReviews
      }
    }
  }
`;

export const OUTLET_SCRAPE_STATUS = `
  query OutletScrapeStatus {
    outletScrapeStatus {
      isRunning
    }
  }
`;

export const LINK_GOOGLE_REVIEW_STORE = `
  mutation LinkGoogleReviewStore($outletId: ID!, $placeId: String!, $address: String!) {
    linkGoogleReviewStore(outletId: $outletId, placeId: $placeId, address: $address) {
      result
      errors {
        message
      }
    }
  }
`;

export const UNLINK_GOOGLE_REVIEW_STORE = `
  mutation UnlinkGoogleReviewStore($outletId: ID!) {
    unlinkGoogleReviewStore(outletId: $outletId) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_STORE_REVIEW_SCRAPING = `
  mutation ToggleStoreReviewScraping($outletId: ID!) {
    toggleStoreReviewScraping(outletId: $outletId) {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_LAST_VISITED_MARKETING = `
mutation UpdateLastVisitedMarketing {
  updateLastVisitedMarketing {
    result
    errors {
      message
    }
  }
}
`;

export const BRAND_AGE_GROUP = `
query Brand($forBroadcast: Boolean, $channel: String) {
  slBrand {
    id
    customersAgeGroup(forBroadcast: $forBroadcast, channel: $channel)
  }
}
`;

export const BRAND_LAST_VISIT = `
query Brand(
  $keyword: String!
  $startDate: String!
  $endDate: String!
  $forBroadcast: Boolean
  ) {
  slBrand {
    id
    lastVisit(
      keyword: $keyword
      startDate: $startDate
      endDate: $endDate
      forBroadcast: $forBroadcast
    )
  }
}
`;

export const DASHBOARD_TRAINING_PROGRAM = `
query DashboardTrainingProgram{
  dashboardTrainingProgram{
    id
    title
    description
    dashboardTutorialPopups{
      id
      location
      title
      description
      videoUrl
      countdownTimer
      buttonText
      code
      enabled
    }
  }
}
`;

export const UPDATE_DASHBOARD_TRAINING_STATUS = `
  mutation UpdateDashboardTrainingStatus($dashboardTutorialPopupId : ID!  ) {
    updateDashboardTrainingStatus(dashboardTutorialPopupId : $dashboardTutorialPopupId ) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_FOREIGN_BROADCAST_MSGS = `
mutation ToggleForeignBroadcastMsgs {
    toggleForeignBroadcastMsgs {
        result
        errors {
            message
        }
    }
}
`;

export const USER_COMPLETED_TRAINING = `
query UserCompletedTrainingPopupIds{
  userCompletedTrainingPopupIds
}
`;

export const PLAN_LIMIT_CONFIG = `
query PlanLimits {
  planLimits {
    name
    databaseLimit
    messageLimit
    additionalDatabaseLimit
  }
}
`;

export const PROGRAM_FINAL_QUIZ_ATTEMPTS = `
query ProgramFinalQuizAttempts {
  programFinalQuizAttempts {
    outlet {
      name
    }
    name
    phoneNumber
    status
    createdAt
    completedAt
    score
    duration
  }
}
`;

export const UNLINK_WHATSAPP = `
mutation UnlinkWhatsapp {
  unlinkWhatsapp {
    result
    errors {
      message
    }
  }
}
`;

// Esb
export const UPDATE_ESB_IDENTIFIER = `
  mutation UpdateEsbIdentifier($outletId: ID!, $esbIdentifier: String!) {
    updateEsbIdentifier(outletId: $outletId, esbIdentifier: $esbIdentifier) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;
export const UPDATE_ESB_CREDENTIALS = `
  mutation UpdateEsbCredentials($token: String!) {
    updateEsbCredentials(token: $token) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const UNLINK_ESB = `
mutation UnlinkEsb($code: String!) {
  unlinkEsb(code: $code) {
    result
    errors {
      message
    }
  }
}
`;

export const GENERATE_UNLINK_INTEGRATION_CODE = `
mutation GenerateUnlinkIntegrationCode($specification: String!) {
  generateUnlinkIntegrationCode(specification: $specification) {
    result
    errors {
      message
    }
  }
}
`;

// Storehub Integration Mutations

export const CREATE_STOREHUB_CERDENTIALS = `
mutation CreateStorehubCredentials (
  $username: String!
  $token: String!
) {
  createStorehubCredentials (
    username: $username
    token: $token
  ) {
    result
    otherPos
    errors { message }  
  }
}
`;

export const UPDATE_STOREHUB_CREDENTIALS = `
mutation UpdateStorehubCredentials (
  $username: String!
  $token: String!
  $credentialId: ID!
) {
  updateStorehubCredentials (
    username: $username
    token: $token
    credentialId: $credentialId
  ) {
    result
    errors { message }
  }
}
`;

export const UPDATE_STOREHUB_STORE_ID_SINGLE = `
mutation UpdateStorehubStoreIdSingle (
  $outletId: ID!
  $storeId: String
) {
  updateStorehubStoreIdSingle (
    storeId: $storeId
    outletId: $outletId
  ) {
    result
    errors { message }
  }
}
`;

export const UPDATE_STOREHUB_STORE_ID_MULTIPLE = `
mutation UpdateStorehubStoreIdMultiple (
  $outletId: ID!
  $storeId: String
  $credentialId: ID!
) {
  updateStorehubStoreIdMultiple (
    storeId: $storeId
    outletId: $outletId
    credentialId: $credentialId
  ) {
    result
    errors { message }
  }
}
`;

export const UNLINK_STOREHUB = `
mutation UnlinkStorehub (
  $code: String!
) {
  unlinkStorehub (
    code: $code
  ) {
    result
    errors { message }
  }
}
`;

export const DINLR_OUTLET_LOCATIONS = `
query DinlrOutletLocations {
  slBrand {
    dinlrOutletLocations {
      outlets {
        id
        name
      }
      errors { message }
    }
  }
}
`;

export const UPDATE_DINLR_CREDENTIALS = `
mutation UpdateDinlrCredentials(
  $code: String!, 
  $restaurantId: String!
) {
  updateDinlrCredentials(
    code: $code
    restaurantId: $restaurantId
  ) {
    result
    errors { message }
  }
}
`;

export const UNLINK_DINLR = `
mutation UnlinkDinlr (
  $code: String!
) {
  unlinkDinlr (
    code: $code
  ) {
    result
    errors { message }
  }
}
`;

export const UPDATE_DINLR_ID = `
mutation UpdateDinlrId (
  $outletId: ID!,
  $locationId: String
) {
  updateDinlrId (
    outletId: $outletId
    locationId: $locationId
  ) {
    result
    otherPos
    errors { message }
  }
}
`;

export const SBSC_REPORT = `
  query SbscReport($campaignId: ID!) {
    sbscReport(campaignId: $campaignId) {
      membersReceived
      membersNotReceived
      returnedReceived
      returnedNotReceived
      avgVisitsReceived
      avgVisitsNotReceived
      medianSpendReceived
      medianSpendNotReceived
      difference
    }
  }
`;

// Hubbo
export const UPDATE_HUBBO_ID = `
  mutation UpdateHubboId(
    $outletId: ID!
    $hubboId: String!
  ) {
    updateHubboId (
      outletId: $outletId
      hubboId: $hubboId
    ) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const UNLINK_HUBBO = `
  mutation UnlinkHubbo($code: String!) {
    unlinkHubbo(code: $code) {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_XILNEX_CREDENTIALS_V2 = `
  mutation updateXilnexCredentialsV2(
    $appId: String!
    $appToken: String!
  ) {
    updateXilnexCredentialsV2(
      appId: $appId
      appToken: $appToken
    ) {
      result
      otherPos
      updatedAt
      errors {
        message
      }
    }
  }
`;

export const ENABLE_XILNEX_FTP_SKU = `
  mutation EnableXilnexFtpSku($appId: String!, $appToken: String!) {
    enableXilnexFtpSku(appId: $appId, appToken: $appToken) {
      result
      errors {
        message
      }
    }
  }
`;

export const DISABLE_XILNEX_FTP_SKU = `
  mutation DisableXilnextFtpSku {
    disableXilnexFtpSku {
      result
      errors {
        message
      }
    }
  }
`;

export const XILNEX_INTEGRATION = `
query ExternalIntegration($spec: String!) {
  externalIntegration(spec: $spec) {
    id
    xilnex {
      appId
      appToken
      collectionEnabled
      redemptionEnabled
      verified
      credentialsUploadTime
      outletSettings
      storeList {
        id
        name
      }
    }
  }
}  
`;

export const XILNEX_FTP_INTEGRATION = `
query ExternalIntegration($spec: String!) {
  externalIntegration(spec: $spec) {
    id
    xilnexFtp {
      collectionEnabled
      redemptionEnabled
      verified
      outletSettings
    }
  }
}  
`;

export const BILLING_INVOICES = `
query BillingInvoices(
  $limit: Int!,
  $currentPage: Int!
  $sort: String!
  $direction: String!
) {
  billingInvoices(
    limit: $limit
    currentPage: $currentPage
    sort: $sort
    direction: $direction
  ) {
    totalRecords
    records {
      id
      invoiceNumber
      invoiceType
      paymentType
      createdAt
      amount
      status
      cardType
      nameOnCard
      last4
    }
  }
}
`;

export const BILLING_PLAN_SUMMARY = `
query BillingPlanSummary {
  billingPlanSummary {
    chargesPerMonth
    plan
    freeTrial
    downgradeOnExpiry
    nextPaymentAmount
    nextPaymentDate
  }
}  
`;

export const BILLING_PAYMENT_METHOD = `
query BillingPaymentMethod {
  billingPaymentMethod {
    paymentType
    companyNames
    cardType
    nameOnCard
    last4
    expiry
    email
  }
}
`;

export const CREATE_BILLING_PORTAL_SESSION = `
mutation CreateBillingPortalSession {
  createBillingPortalSession {
    result
    errors {
      message
    }
    url
  }
}
`;

export const RETRY_FAILED_PAYMENT = `
mutation RetryFailedPayment(
  $billingInvoiceId: ID!
) {
  retryFailedPayment(
    billingInvoiceId: $billingInvoiceId
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const CANCEL_AUTO_RECHARGE = `
  mutation CancelAutoRecharge{
    cancelAutoRecharge{
      result
      errors {
        message
      }
    }
  }
`;

export const SMS_RECHARGE_MULTIPLE = `
  mutation SmsRechargeMultiple (
    $amount: Int!
    $creditBreakdown: [CreditBreakdownInput!]!
  ) {
    smsRechargeMultiple (
    amount: $amount
    creditBreakdown: $creditBreakdown
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const BRAND_BILLING_DETAILS = `
query BrandBillingDetails{
  brandBillingDetails{
    brandId
    name
    creditBalance
    registeredNameId
  }
}
`;

export const REGISTERED_NAME_BILLING_DETAILS = `
query RegisteredNameBillingDetails{
  registeredNameBillingDetails{
    id
    name
    email
    last4
  }
}
`;

export const ADD_CREDIT_CARD = `
  mutation AddCreditCard(
    $registeredNameId: ID!
    $currentPage: String!
  ) {
    addCreditCard(
      registeredNameId: $registeredNameId
      currentPage: $currentPage
    ) {
      result
      url
      errors {
        message
      }
    }
  }
`;

export const SWITCH_SUBSCRIPTION_TO_CREDIT_CARD = `
  mutation SwitchSubscriptionToCreditCard(
    $registeredNameId: ID!
    $currentPage: String!
  ) { 
    switchSubscriptionToCreditCard(
      registeredNameId: $registeredNameId
      currentPage: $currentPage
    ) {
      result
      url
      errors {
        message
      }  
    }
  }
`;

export const BRAND_SUBSCRIPTION_CHECK = `
  query BrandSubscriptionCheck {
    brandSubscriptionCheck {
      hasSubscription
      hasMultipleRegNames
    }
  }
`;

export const SECURITY_HISTORIES = `
query SecurityHistories(
  $currentPage: Int!
  $limit: Int!
  $customerId: ID
  $outletId: ID
) {
  securityHistories(
    currentPage: $currentPage
    limit: $limit
    customerId: $customerId
    outletId: $outletId
  ) {
    totalRecords
    records {
      createdAt
      customerId
      outletName
      assignedTo
      securityCode
      action
    }
  }
}
`;

export const UPDATE_SHOPIFY_ID = `
  mutation UpdateShopifyId(
    $outletId: ID!
    $shopifyId: String
  ) {
    updateShopifyId (
      outletId: $outletId
      shopifyId: $shopifyId
    ) {
      result
      otherPos
    }
  }
`;

export const REWARD_MATCHING_PROMOTIONS = `
  query RewardMatchingPromotions(
    $limit: Int!
    $currentPage: Int!
    $searchInput: String
  ) {
    rewardMatchingPromotions(
      limit: $limit
      currentPage: $currentPage
      searchInput: $searchInput
    ) {
      totalRecords
      records {
        promotionId
        promotionType
        rewardType
        specification
        promotionName
        monetaryCost
        posSettings {
          name
          enabled
        }
        ecomSettings {
          name
          enabled
        }
        shopifyProductId
        integrationItemCode
        discountLimit
        createdAt
        rebateCost
        esbItemCode
        eats365ProductCode
      }
    }
  }
`;

export const TOGGLE_CAMPAIGN_INTEGRATION = `
  mutation ToggleCampaignIntegration(
    $promotionId: ID!,
    $type: String!,
    $integrationName: String!,
    $value: Boolean!,
    $shopifyProductId: String,
    $rebateCost: Float
    $esbItemCode: String,
    $eats365ProductCode: String,
  ) {
    toggleCampaignIntegration(
      promotionId: $promotionId,
      type: $type,
      integrationName: $integrationName,
      value: $value,
      shopifyProductId: $shopifyProductId,
      rebateCost: $rebateCost
      esbItemCode: $esbItemCode
      eats365ProductCode: $eats365ProductCode
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const UNLINK_SHOPIFY_POS = `
  mutation UnlinkShopifyPos($code: String!) {
    unlinkShopifyPos(code: $code) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_SHOPIFY_POS_WEBHOOK = `
  mutation ToggleShopifyPosWebhook($enabled: Boolean!) {
    toggleShopifyPosWebhook(enabled: $enabled) {
    otherPos
    result
      errors {
        message
      }
    }
  }
`;

export const SHOPIFY_POS_LOCATIONS = `
  query ShopifyPosLocations {
    slBrand {
      shopifyPosLocations {
        id
        name
      }
    }
  }
`;

export const SWITCH_LOYALTY_PROGRAM = `
mutation SwitchLoyaltyProgram(
  $code: String!
  $pointsPerStamp: Int!
  $stpcThreshold: Int!
  $stpcModifier: Int!
  $stpcSpecification: String!
  $promotions: [PromotionInput!]!
) {
  switchLoyaltyProgram(
    code: $code
    pointsPerStamp: $pointsPerStamp
    stpcThreshold: $stpcThreshold
    stpcModifier: $stpcModifier
    stpcSpecification: $stpcSpecification
    promotions: $promotions
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const GENERATE_SWITCH_LOYALTY_PROGRAM_CODE = `
mutation GenerateSwitchLoyaltyProgramCode {
  generateSwitchLoyaltyProgramCode {
    result
    errors {
      message
    }
  }
}
`;
export const PROMOTION_SUGGESTIONS = `
  query PromotionSuggestions($currentPage: Int!) {
    promotionSuggestions(currentPage: $currentPage) {
      name
      type
      monetaryCost
      priority
      returnRate
    }
  }
`;

export const CHECK_LIMIT_BROADCAST = `
query CheckLimitBroadcast(
  $totalMessages: String!
) {
  checkLimitBroadcast(
  totalMessages: $totalMessages
  ) {
    result
    message
  }
}
`;

export const UPDATE_EKYC = `
  mutation EditEkyc(
    $fbRequired: Boolean
    $redeemThreshold: Int
    $collectThreshold: Int
    $spentThreshold: Int
  ) {
    editEkyc(
      fbRequired: $fbRequired
      redeemThreshold: $redeemThreshold
      collectThreshold: $collectThreshold
      spentThreshold: $spentThreshold
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const LEADS = `
query Leads($limit: Int!, $currentPage: Int!, $sort: String!, $direction: String!, $firstInteractionChannels: [LeadsChannel!], $lastInteractionChannels: [LeadsChannel!]) {
  leads(limit: $limit, currentPage: $currentPage, sort: $sort, direction: $direction, firstInteractionChannels: $firstInteractionChannels, lastInteractionChannels: $lastInteractionChannels) {
    customerId
    customerName
    imageUrl
    firstInteraction {
      timestamp
      channel
    }
    lastInteraction {
      timestamp
      channel
    }
    conversionTimestamp
  }
}
`;

export const LEAD_STATISTICS = `
query LeadStatistics($firstInteractionChannels: [LeadsChannel!], $lastInteractionChannels: [LeadsChannel!]) {
  leadStatistics(firstInteractionChannels: $firstInteractionChannels, lastInteractionChannels: $lastInteractionChannels) {
    totalLeads
    convertedLeads
  }
}
`;

export const FB_MARKETING_VERIFIED = `
query FbMarketingVerified {
  slBrand {
    brandConfiguration {
      fbMarketingVerified
    }
  }
}
`;

export const FB_USER_DETAILS = `
query FbUserDetails {
  slBrand {
    fbUserDetails {
      name
      profilePicture
      errors {
        message
      }
    }
  }
}
`;

export const RETRIEVE_ALL_FB_ADS = `
query RetrieveAllFbAds {
  slBrand {
    retrieveAllFbAds
  }
}
`;

export const RETRIEVE_ALL_FB_CUSTOM_AUDIENCES = `
query RetrieveAllFbCustomAudiences {
  slBrand {
    retrieveAllFbCustomAudiences
  }
}
`;

export const BRAND_FB_CAMPAIGNS = `
query FbCampaigns(
  $currentPage: Int!,
  $limit: Int!,
  $specification: String,
  $filters: FbOfflineEventSearch!
) {
  slBrand {
    id
    countryCode
    overallFbCampaigns(specification: $specification)
    fbCampaigns(
      currentPage: $currentPage,
      limit: $limit,
      filters: $filters
    ) {
       id
       title
       starting
       ending
       audience
       size
       roi
       visits
       facebookCampaignIdentifier
       metadata
       campaignInfo {
         reach
         budget
         impressions
         costPerConversion
         conversion
         avgConversionValue
         roas
         uniquePurchase
         purchaseAmnt
         purchase
         caption
         imgUrl
         errors {
           message
         }
       }
    }
  }
}
`;

export const BRAND_FB_OFFLINE_EVENTS = `
query brandFbOfflineEvents(
  $limit: Int!,
  $currentPage: Int!,
  $filters: FbOfflineEventSearch!
  ) {
  slBrand {
    id
    fbOfflineEvents(
      limit: $limit,
      currentPage: $currentPage,
      filters: $filters
      ) {
      totalRecords
      fbOfflineEvent {
        id
        adId
        eventId
        archived
        lastTriggeredAt
        status
        campaignInfo {
          adName
          costPerConversion
          avgConversionValue
          conversion
          caption
          roas
          reach
          budget
          impressions
          uniquePurchase
          purchase
          purchaseAmnt
          dateStop
          dateStart
          imgUrl
          errors {
            message
          }
        }
      }
    }
  }
}
`;

export const CHECK_VOID_COLLECTION = `
  mutation CheckVoidCollection($id: ID!) {
    checkVoidCollection(id: $id) {
      result
      possible
      errors {
        message
      }
    }
  }
`;

export const CALC_EDIT_MIN_SPENDING = `
  mutation CalcEditMinSpending($id: ID!) {
    calcEditMinSpending(id: $id) {
      result
      minSpending
      errors {
        message
      }
    }
  }
`;

export const EDIT_COLLECTION_SPENDING = `
  mutation EditCollectionSpending($id: ID!, $spending: Int!) {
    editCollectionSpending(id: $id, spending: $spending) {
      result
      errors {
        message
      }
    }
  }
`;

export const GENERATE_EDIT_COLLECTION_CODE = `
  mutation GenerateEditCollectionCode {
    generateEditCollectionCode {
      result
      errors {
        message
      }
    }
  }
`;

export const VALIDATE_EDIT_COLLECTION_CODE = `
  mutation ValidateEditCollectionCode($code: String!) {
    validateEditCollectionCode(code: $code) {
      result
      errors {
        message
      }
    }
  }
`;

export const BRAND_TERMS_AND_CONDITIONS = `
query SlBrand {
  slBrand {
    termsAndConditions
  }
}
`;

export const LOYALTY_WIDGET_CAMPAIGNS = `
  query LoyaltyWidgetCampaigns {
    loyaltyWidgetCampaigns {
      chanceCampaigns {
        id
        title
        startDate
        endDate
        createdAt
        spins
      }
      reviewCampaigns {
        id
        title
        startTiming
        endTiming
        createdAt
        totalReviews
      }
      multiplierCampaigns {
        id
        eventName
        starting
        ending
        createdAt
        multiplier
        totalParticipated
        rruleData
      }
      referralCampaigns {
        id
        title
        startTiming
        endTiming
        createdAt
        participated
      }
      broadcastCampaigns {
        id
        title
        sentDate
        expiryDate
        createdAt
        roi
      }
    }
  }
`;

export const LOYALTY_WIDGET_AUTOMATIONS = `
  query LoyaltyWidgetAutomations {
    loyaltyWidgetAutomations {
      id
      promotionTitle
      specification
      additionalSales
      createdAt
    }
  }
`;

export const MONTHLY_REPORT = `
  query MonthlyReport($brandId: ID!, $month: String!, $year: Int!) {
    monthlyBrandReport(brandId: $brandId, month: $month, year: $year) {
      brandId
      brandName
      month
      year
      currencySymbol
      currentAddSales
      addSalesDiff
      addSalesDiffPerc
      addSalesIcon
      addSalesColour
      currentProfit
      profitDiff
      profitDiffPerc
      profitDiffIcon
      profitDiffColour
      cogsCost
      smsCost
      smsCostBillingCurrency
      additionalCost
      offerCost
      subscriptionCost
      subscriptionCostBillingCurrency
      associatedCost
      sbscAddSalesPerc
      additionalSalesCostGraphData
      currentAcc
      accDiff
      accDiffPerc
      accDiffIcon
      accDiffColour
      accGraphData
      currentNewMember
      newMemberDiff
      newMemberDiffPerc
      newMemberDiffIcon
      newMemberDiffColour
      currentRepeatMember
      repeatMemberDiff
      repeatMemberDiffPerc
      repeatMemberDiffIcon
      repeatMemberDiffColour
      currentTotalMember
      membershipGraphData
      membershipData{
        title
        count
        threshold
      }
      sbscNewMemberPerc
      eventData {
        multiplier
        title
        participants
      }
      campaignsData {
        spec
        label
        icon
        roi
        returnees
        title
        leftReview
        submissions
        spins
        periodStart
        periodEnd
      }
      memberData {
        id
        name
        newMembers
        percentile    
      }
      featureSuggestion {
        title
        imgUrl
      }
      ongoingCampaignIcon
      credit
      smsSent
      wsSent
      highRisk
      mediumRisk
      redeemSecurity
      visitSecurity
      collectionSecurity
      securityListUrl
      securityTransactionUrl
      blockedDays
    }
    slBrand {
      collectionLimit
    }
  }
`;

export const UPDATE_BRAND_TERMS_AND_CONDITIONS = `
  mutation UpdateBrandTermsAndConditions(
    $termsAndConditions: String!
  ) {
    updateBrandTermsAndConditions(
      termsAndConditions: $termsAndConditions
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const RESET_TNC = `
  mutation ResetTnc {
    resetTnc {
      result
      errors {
        message
      }
    }
  }
`;

export const BROADCAST_FILTER_REFERRAL_CAMPAIGNS = `
query BroadcastFilterReferralCampaigns(
  $limit: Int!
  $currentPage: Int!
) {
  slBrand {
    filteredBroadcastReferralCampaigns(
      limit: $limit
      currentPage: $currentPage
    ) {
      id
      campaignId
      title
      startTiming
      endTiming
      status
    }
  }
}
`;

export const BROADCAST_FILTER_REVIEW_CAMPAIGNS = `
  query BroadcastFilterReviewCampaigns(
    $limit: Int!
    $currentPage: Int!
    $sort: String!
    $direction: String!
    $filters: [String!]
    ) {
    reviewCampaigns(
      limit: $limit
      currentPage: $currentPage
      sort: $sort
      direction: $direction
      filters: $filters
    ) {
      totalRecords
      records {
        campaignId
        title
        status
        startTiming
        endTiming
      }
    }
  }
`;

export const FB_WS_OVERVIEW = `
query FbWsOverview{
  fbWsOverview 
  {
    dailySent
    dailyDelivered
    dailyQuota
    templates {
      total
      approved
      pending
    }
    activeNumberCount
    connectedNumbers {
      id
      wabaPhoneNumber
      useForSending
      label
      wabaName
    }
  }
}
`;

export const CONNECTED_WS_NUMBERS = `
query ConnectedNumbers{
  connectedNumbers {
    id
    wabaPhoneNumber
    useForSending
    label
    wabaName
  }
}
`;

export const UPDATE_WABA_NUMBER_LABEL = `
  mutation UpdateWabaNumberLabel(
    $id: ID!
    $label: String!
  ) {
    updateWabaNumberLabel(
      id: $id
      label: $label
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const REMOVE_WABA_NUMBER = `
  mutation RemoveWabaNumber(
    $id: ID!
  ) {
    removeWabaNumber(
      id: $id
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const SET_DEFAULT_WS_NUMBER = `
  mutation SetDefaultWsNumber(
    $id: ID!
  ) {
    setDefaultWsNumber(
      id: $id
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const BRAND_OFFLINE_EVENT_IDS = `
query brandOfflineEventIds {
  slBrand {
    id
    offlineEventIds
  }
}
`;

export const OPUS_DATA = `
  query SlBrand
  {
    slBrand{
      opusData {
        populated
        existingCategories
        existingProducts
        unimportedProducts
        groupedCategorizedProducts{
          category
          products{
            product
            recommend
          }
        }
        groupedUncategorizedProducts {
          category
          products{
            product
            recommend
          }
        }
        categorizedPerc
        uncategorizedPerc
        categorizedStats
        errors {
          message
        }
      }
    }
  }
`;

export const OPUS_CATEGORIZE = `
      mutation OpusCategorize{
        opusCategorize {
          result
          jobId
          errors {
            message
          }
        }
      }
`;

export const OPUS_IMPORT = `
      mutation OpusImport(
        $jobId: ID!
        $categorization: String
      ) {
        opusImport(
          jobId: $jobId
          categorization: $categorization
        ) {
          result
          errors {
            message
          }
        }
      }
`;

export const OPUS_CATEGORIES = `
  query OpusCategories($jobId: ID!) 
  {
    opusCategories(jobId: $jobId) 
    {
      jobId
      categorization
      error
    }
  }
`;

export const OPUS_IMPORT_STATUS = `
  query OpusImportStatus($jobId: ID!) 
  {
    opusImportStatus(jobId: $jobId) 
    {
      status
      error
    }
  }
`;

export const OPUS_SEARCH = `
  query SlBrand ($search: String!)
  {
    slBrand
    {
      opusSearch(search: $search) 
      {
        groupedCategorizedProducts{
          category
          products{
            product
            recommend
          }
        }
      }
    }
  }
`;

export const OPUS_ADD_CATEGORY = `
      mutation OpusAddCategory(
        $name: String!
      ) {
        opusAddCategory(
          name: $name
        ) {
          result
          errors {
            message
          }
        }
      }
`;

export const OPUS_MOVE_PRODUCT = `
  mutation OpusAddCategorizedProducts($categorizedProducts: [OpusCategorizedProductInput!]!) {
    opusAddCategorizedProducts(categorizedProducts: $categorizedProducts) 
    {
      result
      errors {
         message
      }
    }
  }
`;

export const OPUS_RENAME_CATEGORY = `
  mutation OpusEditCategory(
        $oldName: String!
        $newName: String!
      ) {
        opusEditCategory(
          oldName: $oldName
          newName: $newName
        ) {
          result
          errors {
            message
          }
        }
  }
`;

export const OPUS_REMOVE_CATEGORY = `
  mutation OpusRemoveCategory(
        $name: String!
      ) {
        opusRemoveCategory(
          name: $name
        ) {
          result
          errors {
            message
          }
        }
  }
`;

export const OPUS_TEMPORARY_IMPORT = `
  mutation OpusTemporaryImport($categories: [String!]!, $jobId: String!){
    opusTemporaryImport(categories: $categories, jobId: $jobId) {
      result
      errors {
        message
      }
    }
  }
`;

export const OPUS_JOB_STATUS = `
  query OpusJobStatus($jobId: ID!) 
  {
    opusJobStatus(jobId: $jobId) 
    {
      jobId
      specification
      status
      error
    }
  }
`;

export const COMPLETE_INSIGHT_SETUP = `
  mutation CompleteInsightSetup($aiccoUsers: [String!]!) {
    completeInsightSetup(aiccoUsers: $aiccoUsers) {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_INSIGHT_CONFIG = `
  mutation UpdateInsightConfig(
    $carouselOrder: [String!]
    $aiccoUsers: [String!]
  ) {
    updateInsightConfig(
      carouselOrder: $carouselOrder
      aiccoUsers: $aiccoUsers
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const LAST_TRANSACTION = `
  query SaleMappings(
    $first: Int,
    $after: String,
    $itemLimit: Int
    ) {
    slBrand {
      saleMappings(
      first: $first,
      after: $after,
      itemLimit: $itemLimit
      ) {
        edges {
          node {
            id
            createdAt
            saleItems{
              product
              category
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const INTERESTED_IN = `
  query ShopifyCartItems($limit: Int, $customerId: ID) {
    shopifyCartItems(limit: $limit, customerId: $customerId) {
      id
      name
      quantity
    }
  }
`;

export const OPUS_TOP_SALES = `
  query OpusTopSales
  {
    opusTopSales
    {
      categories{
        name
        amount
      }
      products{
        name
        category
        amount
      }
    }
  }
`;

export const FB_WS_ACCOUNTS = `
  query FbWsAccounts
  {
    fbWsAccounts
    {
      id
      wabaName
    }
  }
`;

export const MINIMUM_RECHARGE_VALUES = `
  query MinimumRechargeValues($currencyId: ID!) {
    minimumRechargeValues(currencyId: $currencyId) {
      id
      currencyId
      defaultSingleCredit
      defaultAutoCredit
      defaultRechargeThreshold
    }
  }
`;

export const REMOVE_CUSTOMER_BLACKLIST = `
mutation RemoveCustomerBlacklist($customerId: ID!) {
  removeCustomerBlacklist(customerId: $customerId) {
    result
    errors {
      message
    }
  }
}
`;

export const OPUS_PRODUCT_FLAG = `
  mutation OpusProductFlag($products: [String!]!, $flag: Boolean!, $newProducts: [String!]){
    opusProductFlag(products: $products, flag: $flag, newProducts: $newProducts) {
      result
      errors {
        message
      }
    }
  }
`;

export const SELECTED_WS_RATE = `
query WsRateCount($memberCount: Int!) {
  wsRateCount(memberCount: $memberCount) {
    whatsappCount
    paymentTotal
    paymentToWa
    paymentToSl
    waCostPrice
  }
}
`;

export const BRAND_ETHNICITY_GROUP = `
  query BrandEthnicityGroup {
    slBrand {
      id
      customersEthnicity
    }
  }
`;

export const BRAND_GENDER_GROUP = `
  query BrandAgeGroup {
    slBrand {
      id
      customersGender
    }
  }
`;

export const MONTHLY_REPORT_STATUS = `
  query MonthlyReportStatus($brandId: ID!, $year: Int!) {
    monthlyReportStatus(brandId: $brandId, year: $year) {
      month
      year
      status
    }
  }
`;

export const EXP_PRIMARY = `
query SlBrand {
  slBrand {
    totalVisits
  }
}
`;

export const EXP_SECONDARY = `
query SlBrand {
  slBrand {
    overallUsers
  }
}
`;

export const EXP_TERTIARY = `
query slBrand {
  slBrand {
    monthlyAdditionalSales
  }
}
`;

export const OMNIBOX_CONVERSATIONS = `
query OmniboxConversations(
  $first: Int,
  $after: String,
  $searchInput: String,
  $filterVisit: String
) {
  omniboxConversations(
    searchInput: $searchInput,
    filterVisit: $filterVisit
  ) {
    records(first: $first, after: $after){
      edges {
        node {
          customerId
          conversationId
          phoneNumber
          name
          externalCustomerId
          igName
          pictureUrl
          content
          messageTimestamp
          totalVisits
          agentPhone
          agentName
          source
          urgent
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    wabaVerified
    igVerified
    urgentCount
  }
}
`;

export const CONVERSATION_MESSAGES = `
query OmniboxConversationMessages(
  $first: Int,
  $after: String,
  $source: String!,
  $customerId: ID,
  $externalCustomerId: String, 
  $agentId: String
) {
  omniboxConversationMessages(
    source: $source,
    customerId: $customerId,
    externalCustomerId: $externalCustomerId, 
    agentId: $agentId
  ) {
    records(first: $first, after: $after) {
      edges {
        node {
          sender
          content
          messageType
          messageTimestamp
          replyTo
          agentId
          agentLabel
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    agents{
      id
      label
    }
  }
}
`;

export const CREATE_STAMP_CONFIGURATION = `
  mutation CreateStampConfiguration(
    $promotionData: StampPromotionInput!
    $description: String!
    $stampsToComplete: Int!
    $textColor: String!
    $cardColorSpecification: String!
    $cardBackgroundColor: String!
    $stampBackgroundColor: String!
    $frontCardUseLogo: Boolean!
    $expiryDays: Int
    $footer: String
    $iconImg: String
    $rewardBackgroundColor: String!
    $rewardIconImg: String!
    $rewardTextColor: String!
  ) {
    createStampConfiguration(
      promotionData: $promotionData
      description: $description
      stampsToComplete: $stampsToComplete
      textColor: $textColor
      cardColorSpecification: $cardColorSpecification
      cardBackgroundColor: $cardBackgroundColor
      stampBackgroundColor: $stampBackgroundColor
      frontCardUseLogo: $frontCardUseLogo
      expiryDays: $expiryDays
      footer: $footer
      iconImg: $iconImg
      rewardBackgroundColor: $rewardBackgroundColor
      rewardIconImg: $rewardIconImg
      rewardTextColor: $rewardTextColor
    ) {
      result
      stampConfigurationId
      errors {
        message
      }
    }  
  }
`;

export const UPDATE_STAMP_CONFIGURATION = `
  mutation UpdateStampConfiguration(
    $description: String!
    $textColor: String!
    $cardColorSpecification: String!
    $cardBackgroundColor: String!
    $stampBackgroundColor: String!
    $frontCardUseLogo: Boolean!
    $footer: String
    $iconImg: String
    $rewardBackgroundColor: String!
    $rewardIconImg: String!
    $rewardTextColor: String!
  ) {
    updateStampConfiguration(
      description: $description
      textColor: $textColor
      cardColorSpecification: $cardColorSpecification
      cardBackgroundColor: $cardBackgroundColor
      stampBackgroundColor: $stampBackgroundColor
      frontCardUseLogo: $frontCardUseLogo
      footer: $footer
      iconImg: $iconImg
      rewardBackgroundColor: $rewardBackgroundColor
      rewardIconImg: $rewardIconImg
      rewardTextColor: $rewardTextColor
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const MAIN_STAMP_CONFIGURATION = `
  query MainStampConfiguration {
    mainStampConfiguration {
      id
      version
      stampsToComplete
      status
      description
      textColor
      iconUrl
      iconImg
      cardColorSpecification
      cardBackgroundColor
      stampBackgroundColor
      footer
      frontCardImageUrl
      expiryDays
      rewardIconImg
      rewardImageUrl
      rewardBackgroundColor
      rewardTextColor
      cardsIssued
      totalMembers
      redeemed
      completed
      promotion {
        promotionType
        title
        monetaryCost
      }
      stpc {
        id
        modifier
        threshold
        specification
      }
    }
    
  }
`;

export const ALL_STAMP_CONFIGURATIONS = `
  query AllStampConfigurations (
    $currentPage: Int!
    $limit: Int!
    $status: String
  ) {
    allStampConfigurations (
      currentPage: $currentPage
      limit: $limit
      status: $status
    ) {
      totalRecords
      records {
        id
        version
        stampsToComplete
        status
        description
        textColor
        iconUrl
        iconImg
        cardColorSpecification
        cardBackgroundColor
        stampBackgroundColor
        footer
        frontCardImageUrl
        expiryDays
        promotion {
          promotionType
          title
          monetaryCost
        }
        cardsIssued
        totalMembers
        redeemed
        roi
        completed
        createdAt
        rewardIconImg
        rewardImageUrl
        rewardBackgroundColor
        rewardTextColor
      }
    }
  }
`;

export const VOID_STAMP_CARDS = `
  mutation VoidStampCards (
    $stampConfigurationId: ID!
    $code: String!
  ) {
    voidStampCards (
      stampConfigurationId: $stampConfigurationId
      code: $code
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const GENERATE_VOID_STAMP_CARD_CODE = `
  mutation GenerateVoidStampCardCode {
    generateVoidStampCardCode {
      result
      errors {
        message
      }
    }
  }
`;

export const INDUSTRIES = `
  query Industries {
    industry {
      id
      name
      mode
      aovMultiplier
    }
  }
`;

export const INDUSTRY_CONFIGURATION = `
  query industryConfiguration($industryId: ID!) {
    industryConfiguration(industryId: $industryId) {
      t1ValueOfRedemption
      t2ValueOfRedemption
      t3ValueOfRedemption
      t1NoOfVisits
      t2NoOfVisits
      t3NoOfVisits
    }
  }
`;

export const GET_CURRENCY_RATE = `
query currencyRateDefaults($countryCode: String!, $industryId: ID!) {
  currencyRateDefaults(countryCode: $countryCode, industryId: $industryId) {
    currency
    point
  }
}`;

export const COUNTRIES = `
  query Countries {
    countries {
      id
      code
      name
      currency {
        code
      }
      spendingCurrency {
        code
        symbol
      }
    }
  }
`;

export const MEMBERSHIP_OVERVIEWS = `
  query MembershipOverviews {
    membershipOverviews {
      membershipId
      name
      color
      totalMembers
      lastMonthDifference
      additionalSales
      tierRequirement
      medianSpend
      averageVisits
      rewards
      totalRewards
      redemptions
    }
  }
`;

export const MEMBERSHIP_PROGRESSIONS = `
  query MembershipProgressions(
    $membershipId: ID!,
    $specification: String!,
  ) {
    membershipProgressions(
      membershipId: $membershipId,
      specification: $specification,
    ){
      oldMembership
      newMembership
      totalMembers
    }
  }
`;

export const MEMBERSHIP_REWARD_PERFORMANCE = `
  query MembershipRewardPerformances(
    $membershipId: ID!,
  ) {
    membershipRewardPerformances(
      membershipId: $membershipId,
    ){
      membershipBenefitId
      name
      rewardsSent
      redemptions
      returnedAndSpent
      benefitType
    }
  }
`;

export const TOTAL_MEMBERSHIPS = `
  query TotalMemberships(
    $membershipId: ID!,
    $period: Int!,
  ) {
    totalMemberships(
      membershipId: $membershipId,
      period: $period,
    ){
      month
      year
      totalMembers
    }
  }
`;

export const MEMBERSHIP_ADDITIONAL_SALES = `
  query MembershipAdditionalSales(
    $membershipId: ID!,
    $period: Int!,
  ) {
    membershipAdditionalSales(
      membershipId: $membershipId,
      period: $period,
    ){
      month
      year
      additionalSales
    }
  }
`;

export const ONGOING_REFERRAL_CAMPAIGN = `
query OngoingReferralCampaign {
  slBrand {
    ongoingReferralCampaign {
      id
      referralId
      campaignId
      title
      startTiming
      endTiming
      promotion {
        title
      }
    }
  }
}
  `;

export const ONGOING_CONNECTED_REVIEW_CAMPAIGNS = `
query OngoingConnectedReviewCampaigns {
  ongoingConnectedReviewCampaigns {
    organizerId
    reviewId
    campaignId
    title
    promotionName
    startTiming
    endTiming
  }
}
  `;

export const DM_PROMOTIONS = gql`
  query DmPromotions(
    $sort: String
    $direction: String
    $filters: PromotionSearch
    $limit: Int
  ) {
    brand: slBrand {
      id
      promotions(
        sort: $sort
        direction: $direction
        filters: $filters
        limit: $limit
      ) {
        id
        title
        cost
        active
        promotionType
        monetaryCost
      }
    }
  }
`;

export const INSTAGRAM_PROFILE_INFO = `
query InstagramProfileInfo {
  instagramProfileInfo {
    id
    userName
    userHandle
    profilePictureUrl
  }
}
`;

export const INSTAGRAM_POSTS = `
query InstagramPosts($limit: Int, $after: String) {
  instagramPosts(limit: $limit, after: $after) {
    posts{
      id
      mediaType
      mediaUrl
      thumbnailUrl
      permalink
      caption
      timestamp
    }
    after
    hasOngoingAutomation
  }
}
`;

export const INSTAGRAM_STORIES = `
query InstagramStories {
  instagramStories {
    story{
      id
      mediaType
      mediaUrl
      thumbnailUrl
      timestamp
    }
    hasOngoingAutomation
  }
}
`;

export const CREATE_IG_DM_ORGANIZER = `
  mutation CreateIgDmOrganizer(
    $name: String! 
    $triggerType: String! 
    $directMessageContent: String! 
    $contentId: [String!] 
    $keywordSpecification: String! 
    $keywords: [String!] 
    $ctaContent: [CtaContentInput!]!
    $messageType: String!
    $oneTimeRedemption: Boolean!
    $externalOrganizerType: String
    $externalOrganizerId: Int
    $mediaContent: [InstagramMediaInput!]
  )
  {
    createIgDmOrganizer(
      name: $name
      triggerType: $triggerType 
      directMessageContent: $directMessageContent 
      contentId: $contentId 
      keywordSpecification: $keywordSpecification 
      keywords: $keywords 
      ctaContent: $ctaContent 
      messageType: $messageType
      oneTimeRedemption: $oneTimeRedemption
      externalOrganizerType: $externalOrganizerType
      externalOrganizerId: $externalOrganizerId
      mediaContent: $mediaContent
    ) 
    {
      result
      errors {
        message
      }
    }
  }
`;

export const INSTAGRAM_LATEST_INTERACTIONS = `
query InstagramLatestInteractions {
  instagramLatestInteractions {
    id
    name
    profilePictureUrl
    interactionType
    message
    createdAt
  }
}
`;

export const INSTAGRAM_HISTORY = `
query InstagramHistory(
  $limit: Int!
  $currentPage: Int!
  $sort: String!
  $direction: String!
) {
  instagramHistory(
    limit: $limit
    currentPage: $currentPage
    sort: $sort
    direction: $direction
  ) {
    history {
      organizerId
      organizerName
      username
      status
      externalOrganizerName
      externalOrganizerType
      creationDate
      directMessageContent
      uniqueUsersCount
      totalMsgSent
      usersSent
      totalMsgDelivered
      usersDelivered
      totalMsgRead
      usersRead
      deliveredPercentage
      openedPercentage
      totalClicks
      uniqueClicks
      roi
      campaignMetric
      keywords
      keywordSpecification
      triggerType
      buttons {
        text
        url
        clickCount
        ctr
      }
      mediaContent {
        id
        mediaUrl
        mediaType
        thumbnailUrl
        permalink
        caption
        timestamp
        imageUrl
      }
      mediaContentFetchedAt
      usersInteracted {
        name
        handle
        profilePictureUrl
      }
      messageType
    }
    totalRecords
  }
}
`;

export const MEMBERS_V2 = `
query MembersV2 ($filterType: String!, $inputs: [CustomerFilterAttributes!], $limit: Int, $currentPage: Int!)
{
  slBrand {
    overallUsers
    fullCustomersByFilterV2(filterType: $filterType, inputs: $inputs, limit: $limit, currentPage: $currentPage) {
      filteredUserCount
      customers {
        id
        name
        email
        phoneNumber
        extension
        birthdate
        availablePoints
        collectedPoints
        collectedStamps
        completedStampCards
        latestStampCard {
          stampsCollected
          stampsToComplete
        }
        totalVisits
        totalSpending
        firstVisit
        lastVisit
        lastVisited
        durationWithBrand
        lastContacted
        blacklist
        marketingOptStatus
        instaProfile{
          name
          handle
          profilePictureUrl
        }
      }
    }
  }
}
`;

export const REWARD_REMINDER_PROMOTIONS = `
  query RewardReminderPromotions(
    $first: Int
    $after: String
    $filters: PromotionSearch
    $sort: String
    $direction: String
  ) {
    rewardReminderPromotions(
      first: $first
      after: $after
      filters: $filters
      sort: $sort
      direction: $direction
    ) {
      edges {
        node {
          id
          title
          promotionType
          imageUrl
          cost
          active
          toRemind
          stampConfigurations {
            status
            expiryDays
          }
          sent
          redeemed
          redeemedAndSpent
          additionalSales
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const REDEMPTION_ANALYTICS = `
  query RedemptionAnalytics($month: Int, $year: Int) {
    redemptionAnalytics(month: $month, year: $year) {
      activeRewards
      rewardsRedeemed
      totalRedemptions
      membersRedeemed
      totalAdditionalSales
    }
  }
`;

export const REDEMPTION_ANALYTICS_REWARDS = `
  query RedemptionAnalyticsRewards(
    $first: Int
    $after: String
    $month: Int
    $year: Int
    $statuses: [String!]
    $search: String
  ) {
    redemptionAnalyticsRewards(
      first: $first
      after: $after
      month: $month
      year: $year
      statuses: $statuses
      search: $search
    ) {
      edges {
        node {
          id
          title
          active
          archived
          cost
          imageUrl
          promotionType
          rank
          redemptions
          percentage
          members
          additionalSales
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const REDEMPTION_ANALYTICS_MONTHS = `
  query RedemptionAnalyticsMonths {
    redemptionAnalyticsMonths {
      month
      year
    }
  }
`;

export const REWARD_STORE_BREAKDOWN = `
  query RewardStoreBreakdown($promotionId: ID!, $month: Int, $year: Int) {
    rewardStoreBreakdown(promotionId: $promotionId, month: $month, year: $year) {
      outletId
      outletName
      redemptions
      percentage
      members
    }
  }
`;

export const REWARD_HISTORY = `
  query RewardHistory(
    $currentPage: Int!
    $limit: Int!
    $startMonth: Int
    $startYear: Int
    $endMonth: Int
    $endYear: Int
    ) {
    rewardHistory(
      currentPage: $currentPage
      limit: $limit
      startMonth: $startMonth
      startYear: $startYear
      endMonth: $endMonth
      endYear: $endYear
    ) {
      totalRecords
      records {
        id
        title
        rewardDisplayName
        active
        archived
        toRemind
        createdAt
        cost
        remindersSent
        redemptionReminderLimit
        reminderTemplate
        reminderNameholder
        totalRedemptions
        redeemedAndSpent
        redeemedOnly
        additionalSales
      }
    }
  }
`;

export const NEW_MEMBERS_COUNT = `
  query newMemberReports(
    $month: Int!
    $year: Int!
    $outletId: ID
    ) { 
    newMemberReports(
      month: $month
      year: $year
      outletId: $outletId
      ) {
        newMembers
        totalMembers
        returningMembers
        totalCurrentMonthMembers
        lapsedMembers
        dormantMembers
        newMembersPrev
        returningMembersPrev
        totalMonthlyMembersPrev
        lapsedMembersPrev
        dormantMembersPrev
        blacklistedMembers
        optedOutMembers
    }
  }
`;

export const MEMBER_PATTERNS = `
query MemberPatterns {
  memberPatterns {
    totalMembers
    registeredProfiles
    metaVerified
    highestFootTraffic {
      day
      time
    }
    medianSpend
    topAgeGroup
    returnRate
  }
}
`;

export const MEMBER_SPEND_PER_VISIT = `
query MemberSpendPerVisit($month: Int!, $year: Int!) {
  memberSpendPerVisit(month: $month, year: $year) {
    maxSpendLowerBound
    maxSpendUpperBound
    records {
      lowerBound
      upperBound
      totalMembers
    }
  }
}
`;
export const MONTHLY_VISIT_REPORT = `
query MonthlyVisitReport($year: Int!, $month: Int!) {
  monthlyVisitReport(year: $year, month: $month) {
    count1
    count2
    count3
    count4More
    spendCount1
    spendCount2
    spendCount3
    spendCount4More
  }
}
`;

export const MEMBER_AGE = `
query MemberAge($outletId: ID) {
  memberAge(outletId: $outletId) {
    maxAgeGroup
    data {
      countBelow18
      count1824
      count2534
      count3555
      countAbove55
    }
  }
}
`;

export const MEMBER_NATIONALITY = `
query MemberNationality($outletId: ID) {
  memberNationality(outletId: $outletId) {
    localMembers
    internationalMembers {
      countryCode
      totalMembers
    }
  }
}
`;

export const DATA_ACCURACY = `
query DataAccuracy($month: Int, $year: Int, $outletId: ID) {
  dataAccuracy(month: $month, year: $year, outletId: $outletId) {
    transactions
    collections
    redemptions
  }
}`;

export const MEMBER_STORE_BREAKDOWNS = `
query MemberStoreBreakdowns($month: Int, $year: Int) {
  memberStoreBreakdowns(month: $month, year: $year) {
    outletName
    visits
    members
  }
}
`;

export const MEMBER_FOOT_TRAFFIC = `
query MemberFootTraffic($month: Int, $year: Int, $dayOfWeek: Int!, $outletId: ID) {
  memberFootTraffic(month: $month, year: $year, dayOfWeek: $dayOfWeek, outletId: $outletId) {
    dayOfWeek
    trafficData   
  }
}
`;

export const MEMBER_FOOT_TRAFFIC_OVERVIEW = `
query MemberFootTrafficOverview($month: Int, $year: Int, $outletId: ID) {
  memberFootTrafficOverview(month: $month, year: $year, outletId: $outletId) {
    maxDay
    maxTime
    minDay
    minTime
  }
} 
`;

export const MEMBER_ANALYTICS_MONTHS = `
query memberAnalyticsMonths($type: String!) {
  memberAnalyticsMonths(type: $type) {
    month
    year
  }}
`;

export const IG_DM_ORGANIZERS = `
query IgDmOrganizers(
  $status: String!
  $direction: String!
) {
  igDmOrganizers(
    direction: $direction
    status: $status
  ) {
    organizers {
      id
      name
      username
      triggerType
      messageType
      directMessageContent
      externalOrganizerType
      status
      keywordSpecification
      keywords
      ctaContent {
        title
        url
        type
        enabled
        position
      }
      mediaContent {
        id
        mediaUrl
        mediaType
        thumbnailUrl
        permalink
        caption
        timestamp
        imageUrl
      }
      mediaContentFetchedAt

    }
    hasAutomation
  }
}
`;

export const TOGGLE_IG_DM_ORGANIZER_STATUS = `
mutation ToggleIgDmOrganizerStatus(
  $id: ID!
  $status: String!
) {
  toggleIgDmOrganizerStatus(
    id: $id
    status: $status
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const UPDATE_IG_DM_ORGANIZER_CONTENT = `
mutation UpdateIgDmOrganizerContent(
  $id: ID!
  $ctaContent: [CtaContentInput!]
  $directMessageContent: String
) {
  updateIgDmOrganizerContent(
    id: $id
    ctaContent: $ctaContent
    directMessageContent: $directMessageContent
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const OPUS_RESET_CATEGORIZATION = `
  mutation OpusResetCategorization {
    opusResetCategorization{
      result
      jobId
      errors {
        message
      }
    }
  }
`;

export const OPUS_RECATEGORIZE_CATEGORY = `
  mutation OpusRecategorizeCategory(
    $source: [String!]!, 
    $target: String!
  )
  {
    opusRecategorizeCategory(
      source: $source, 
      target: $target
    ) 
    {
      result
      jobId
      errors {
        message
      }
    }
  }
`;

export const OPUS_JOB_COMPLETED = `
  mutation OpusJobCompleted($jobId: String!, $jobStatus: String!){
    opusJobCompleted(jobId: $jobId, jobStatus: $jobStatus) {
      result
      errors {
        message
      }
    }
  }
`;

export const OUTLET_IN_CHANCE_CAMPAIGN = `
query activeChance {
  slBrand {
    multipleChanceOutlet {
      outletId
      startDate
      endDate
    }
  }
}
`;

export const UPDATE_FEATURE_TRACKING = `
mutation UpdateFeatureTracking($feature: String!){
  updateFeatureTracking(feature: $feature) {
    result
    errors {
      message
    }
  }
}
`;

export const WALLET_CONFIGURATIONS = gql`
  query WalletConfigurations {
    slBrand {
      walletConfigurations {
        id
        backgroundColor
        barcodeType
        barcodeAlternateText
        heroBannerUrl
        primaryTextColor
        labelTextColor
      }
    }
  }
`;

export const UPDATE_WALLET_CONFIGURATION = gql`
  mutation UpdateWalletConfiguration(
    $backgroundColor: String!
    $barcodeType: String!
    $barcodeAlternateText: String!
    $primaryTextColor: String
    $labelTextColor: String
  ) {
    updateWalletConfiguration(
      backgroundColor: $backgroundColor
      barcodeType: $barcodeType
      barcodeAlternateText: $barcodeAlternateText
      primaryTextColor: $primaryTextColor
      labelTextColor: $labelTextColor
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_SHOW_WALLET = gql`
  mutation ToggleShowWallet($showWallet: Boolean!) {
    toggleShowWallet(showWallet: $showWallet) {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_POST_LOGIN_SEEN_STATUS = `
  mutation UpdatePostLoginSeenStatus($postLoginAnnouncementId : ID!  ) {
    updatePostLoginSeenStatus(postLoginAnnouncementId : $postLoginAnnouncementId ) {
      result
      errors {
        message
      }
      }
    }
`;

export const UPDATE_LOYVERSE_ID = `
  mutation UpdateLoyverseId(
    $outletId: ID!
    $loyverseId: String!
  ) {
    updateLoyverseId (
      outletId: $outletId
      loyverseId: $loyverseId
    ) {
      result
      otherPos
      errors {
        message
      }
    }
  }
`;

export const TOTAL_WALLET_INSTALLATIONS = gql`
  query TotalWalletInstallations(
    $specification: String!
    $privilegeCardConfigurationId: ID
    $date: String
  ) {
    slBrand {
      totalWalletInstallations(
        specification: $specification
        privilegeCardConfigurationId: $privilegeCardConfigurationId
        date: $date
      ) {
        google
        apple
      }
    }
  }
`;

export const BRAND_ONGOING_MARKETING = `
query BrandOngoingMarketing {
  slBrand {
    brandOngoingMarketing 
  }
}
`;

export const DASHBOARD_RETURN_AND_MEDIAN = `
query BrandsReturnsAndMedian{
  brandsReturnsAndMedian{
    brandId
    returnRate
    medianSpend
    brandIndustryName
  }
}
`;

export const UPDATE_BRAND_POINTS_NAME = gql`
  mutation UpdateBrandPointsName($pointsName: String!) {
    updateBrandPointsName(pointsName: $pointsName) {
      result
      errors {
        message
      }
    }
  }
`;

export const HIDE_POINT_NAME_WARNING = gql`
  mutation HidePointNameWarning {
    hidePointRenameWarning {
      result
      errors {
        message
      }
    }
  }
`;

export const FB_ADS_ACCOUNT_DETAILS = `
query FbAdsAccountDetails{
  slBrand {
    fbAdsAccountDetails {
      accountId
      name
    }
  }
}
`;

export const CREATE_PRIVILEGE_CARD = gql`
  mutation CreatePrivilegeCard(
    $backgroundColor: String!
    $privilegeName: String!
    $rewardName: String!
    $expiryDays: Int
    $expiryDate: String
    $primaryTextColor: String!
    $labelTextColor: String!
    $referralId: String!
    $barcodeType: String!
    $barcodeAlternateText: String
    $posIntegration: String
    $promotion: PromotionInput
    $privilegeImageUrl: String
  ) {
    createPrivilegeCard(
      backgroundColor: $backgroundColor
      privilegeName: $privilegeName
      rewardName: $rewardName
      expiryDays: $expiryDays
      expiryDate: $expiryDate
      primaryTextColor: $primaryTextColor
      labelTextColor: $labelTextColor
      referralId: $referralId
      barcodeType: $barcodeType
      barcodeAlternateText: $barcodeAlternateText
      posIntegration: $posIntegration
      promotion: $promotion
      privilegeImageUrl: $privilegeImageUrl
    ) {
      result
      cardConfigId
      integrationItemCode
      errors {
        message
      }
    }
  }
`;

export const UPDATE_PRIVILEGE_CARD = gql`
  mutation UpdatePrivilegeCard(
    $id: ID!
    $backgroundColor: String!
    $privilegeName: String!
    $rewardName: String!
    $expiryDays: Int
    $expiryDate: String
    $primaryTextColor: String!
    $labelTextColor: String!
    $referralId: String!
    $barcodeType: String!
    $barcodeAlternateText: String
    $posIntegration: String
    $promotion: PromotionInput
  ) {
    updatePrivilegeCard(
      id: $id
      backgroundColor: $backgroundColor
      privilegeName: $privilegeName
      rewardName: $rewardName
      expiryDays: $expiryDays
      expiryDate: $expiryDate
      primaryTextColor: $primaryTextColor
      labelTextColor: $labelTextColor
      referralId: $referralId
      barcodeType: $barcodeType
      barcodeAlternateText: $barcodeAlternateText
      posIntegration: $posIntegration
      promotion: $promotion
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const PRIVILEGE_CARDS = gql`
  query PrivilegeCards(
    $first: Int
    $after: String
    $filter: String
    $search: String
    $month: Int!
    $year: Int!
  ) {
    slBrand {
      privilegeCards(
        first: $first
        after: $after
        filter: $filter
        search: $search
      ) {
        edges {
          node {
            id
            backgroundColor
            privilegeName
            rewardName
            expiryDays
            expiryDate
            primaryTextColor
            labelTextColor
            privilegeImageUrl
            active
            createdAt
            participated
            referralId
            activeMembers
            activeMembersMonthly(month: $month, year: $year)
            barcodeType
            barcodeAlternateText
            promotion {
              title
              monetaryCost
              posSettings {
                name
                enabled
              }
              promotionType
              discountLimit
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const PRIVILEGE_CARD_DETAILS = gql`
  query PrivilegeCardDetails($privilegeCardId: ID!, $index: Int) {
    slBrand {
      privilegeCardDetails(privilegeCardId: $privilegeCardId) {
        id
        backgroundColor
        privilegeName
        rewardName
        expiryDays
        expiryDate
        primaryTextColor
        labelTextColor
        privilegeImageUrl
        active
        createdAt
        referralId
        participated
        currentMembers
        barcodeType
        barcodeAlternateText
        returnees
        expiredRedemptions
        returnedAndSpent
        totalRedemptions
        roi
        activeMembersBreakdown {
          google
          apple
        }
        activeMembersReport(index: $index) {
          monthStart
          count
        }
        promotion {
          title
          monetaryCost
          posSettings {
            name
            enabled
          }
          specification
        }
      }
    }
  }
`;

export const TOGGLE_PRIVILEGE_CARD = gql`
  mutation TogglePrivilegeCard($id: ID!, $active: Boolean!) {
    togglePrivilegeCard(privilegeCardId: $id, active: $active) {
      result
      errors {
        message
      }
    }
  }
`;

export const MATCHING_REFERRAL_IDS = gql`
  query MatchingReferralIds($referralId: String!) {
    slBrand {
      matchingReferralIds(referralId: $referralId)
    }
  }
`;

export const DELETE_PRIVILEGE_CARD = gql`
  mutation DeletePrivilegeCard($id: ID!) {
    deletePrivilegeCard(privilegeCardId: $id) {
      result
      errors {
        message
      }
    }
  }
`;

export const ENTRI_JWT = `
query EntriJwt {
  entriJwt
}
`;

export const SETUP_INTERNAL_DOMAIN = `
mutation SetupInternalDomain($senderName: String!, $email: String!) {
  setupInternalDomain(senderName: $senderName, email: $email) {
    result
    errors {
      message
    }
  }
}
`;

export const SETUP_DOMAIN = `
mutation SetupDomain($senderName: String!, $email: String!) {
  setupDomain(senderName: $senderName, email: $email) {
    dnsRecords
    errors {
      message
    }
  }
}
`;

export const UPDATE_DOMAIN_SENDER = `
mutation UpdateDomainSender($sender: String, $senderName: String) {
  updateDomainSender(sender: $sender, senderName: $senderName) {
    result
    errors {
      message
    }
  }
}
`;

export const VALID_DNS = `
query ValidDns($email: String!) {
  validDns(email: $email)
}
`;

export const SCHEDULE_XILNEX_MANUAL_CAMPAIGN = gql`
  mutation ScheduleXilnexManualCampaign($id: ID!) {
    scheduleXilnexManualCampaign(id: $id) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_FOREIGN_REDEMPTION_REMINDER_MSG = gql`
  mutation ToggleForeignRedemptionReminderMsg {
    toggleForeignRedemptionReminderMsgs {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_MEMBERSHIP_FOREIGN_MESSAGES = gql`
  mutation ToggleMembershipForeignMessages {
    toggleMembershipForeignMessages {
      result
      errors {
        message
      }
    }
  }
`;

export const BRAND_PORTAL_ANALYTICS = `
query BrandPortalAnalytics($month: Int, $year: Int) {
  brandPortalAnalytics(month: $month, year: $year) {
    totalVisit
    memberVisit
    visitedStore
    leadVisit
    customCarouselMonthClick
    customCarouselMonthCtr
    instaCarouselMonthClick
    instaCarouselMonthCtr
    linksMonthClick
    linksMonthCtr
    installAppMonth
    installAppRate
    installAppTotal
    rewardImpression
    rewardRedeemed
    redemptionRate
    customCarouselAnalytics {
      carouselId
      carouselClicks
      carouselClickRate
    }
    instaCarouselAnalytics {
      carouselId
      carouselClicks
      carouselClickRate
    }
    linksAnalytics {
      linkId
      linksClicks
      linksClickRate
    }
  }
}
`;

export const EDIT_UNVERIFIED_EMAIL_SECURITY_CONFIG = `
mutation EditUnverifiedEmailSecurityConfig(
  $unverifiedEmailRedemptionLimit: Int
){
  editUnverifiedEmailSecurityConfig(
    unverifiedEmailRedemptionLimit: $unverifiedEmailRedemptionLimit
  ) {
    result
    errors {
      message
    }
  }
}
`;

export const PORTAL_ANALYTICS_MONTHS = `
query PortalAnalyticsMonths {
  portalAnalyticsMonths {
    month
    year
  }
}
`;

export const REMOVE_PRIVILEGED_CUSTOMER = gql`
  mutation RemovePrivilegedCustomer(
    $customerId: ID!
    $privilegeCardRedemptionId: ID!
  ) {
    toggleRemovePrivilegedMember(
      customerId: $customerId
      privilegeCardRedemptionId: $privilegeCardRedemptionId
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_NEED_EMAIL_VERIFICATION = `
  mutation ToggleNeedEmailVerification {
    toggleNeedEmailVerification {
      result
      errors {
        message
      }
    }
  }
`;

export const DEFAULT_CONNECTED_NUMBER = `
  query DefaultConnectedWsNumber {
    defaultConnectedNumber {
      id
      wabaPhoneNumber
      useForSending
      wabaName
    }
  }
`;

export const TOGGLE_WHATSAPP_CHAT_AUTOMATION = `
  mutation ToggleWhatsappChatAutomation($status: Boolean!, $code: String) {
    toggleWhatsappChatAutomation(status: $status, code: $code) {
      result
      errors {
        message
      }
    }
  }
`;

export const BLACKLIST_PRIVILEGED_CUSTOMER = gql`
  mutation BlacklistPrivilegedCustomer(
    $customerId: ID!
    $privilegeCardConfigurationId: ID!
    $reactivateRedemption: Boolean!
  ) {
    toggleBlacklistPrivilegedMember(
      customerId: $customerId
      privilegeCardConfigurationId: $privilegeCardConfigurationId
      reactivateRedemption: $reactivateRedemption
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const DEFAULT_WHATSAPP_MESSAGES = `
  query DefaultWhatsappMessages {
    slBrand {
      id
      defaultWhatsappMessages {
        countryId
        regName
        nameFail
        regBirthday
        birthdayFail
        regEmail
        emailFail
        memberSummary
        redeemFail
        redeemConfirm
        rewardCode
      }
    }
  }
`;

export const PRIVILEGE_CARD_SUGGESTIONS = gql`
  query PrivilegeCardSuggestions {
    privilegeCardSuggestions {
      backgroundColor
      privilegeName
      rewardName
      privilegeImageUrl
      primaryTextColor
      labelTextColor
      description
      priority
    }
  }
`;

export const OUTLET_DAILY_REPORT = `
  query OutletDailyReport(
    $reportDate: String!
    $first: Int!
    $after: String
    $outletId: ID
    ) {
    outletDailyReport(
      reportDate: $reportDate
      first: $first
      after: $after
      outletId: $outletId
      ) {
        edges {
          node {
            reportDate
            outletName
            transactions
            transactionsCredited
            dataAccuracyRate
            rewardsRedeemed
            smsesRedeemed
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
  }
`;

export const TRACK_DASHBOARD_BUTTON_CLICK = `
  mutation TrackDashboardButtonClick(
    $button: String!
  ) {
    trackDashboardButtonClick(
      button: $button
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const CREATE_ZEONIQ_ID = `
  mutation CreateZeoniqId($outletId: ID!, $zeoniqId: String!) {
    createZeoniqId(outletId: $outletId, zeoniqId: $zeoniqId) {
      result
      linkId
      otherPos
      errors {
        message
      }
    }
  }
`;

export const TOGGLE_ZEONIQ_ID_STATUS = `
  mutation ToggleZeoniqIdStatus($linkId: ID!) {
    toggleZeoniqIdStatus(linkId: $linkId) {
      result
      errors {
        message
      }
    }
  }
`;

export const DELETE_ZEONIQ_ID = `
  mutation DeleteZeoniqId($linkId: ID!) {
    deleteZeoniqId(linkId: $linkId) {
      result
      errors {
        message
      }
    }
  }
`;
export const WS_TEMPLATE_ASSIGNMENTS = `
  query WsTemplateAssignments {
    wsTemplateAssignments {
      automationStep
      fbWsTemplateId
      fbWsTemplateName
      fbWsTemplateBodyContent
      fbWsTemplateLastUpdatedTime
      sentCount
      recipientCount
      assignedPromotionIds
    }
  }
`;

export const USER_DASHBOARD_POPUP_SHOWN = `
  query UserDashboardPopupShown($popup: String!) {
    userDashboardPopupShown(popup: $popup)
  }
`;

export const UPDATE_DASHBOARD_POPUP_STATUS = `
  mutation UpdateDashboardPopupStatus($popup: String!) {
    updateDashboardPopupStatus(popup: $popup) {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_WS_TEMPLATE_ASSIGNMENT = `
  mutation UpdateWsTemplateAssignment(
    $id: ID!
    $automationStep: String!
  ) {
    updateWsTemplateAssignment(
      id: $id
      automationStep: $automationStep
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const CREATE_WS_STEP_TEMPLATE = `
  mutation createWsStepTemplate(
    $automationStep: String!
    $bodyContent: String!
  ) {
    createWsStepTemplate(
      automationStep: $automationStep
      bodyContent: $bodyContent
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const WS_REGISTRATION_STATS = `
  query WsRegistrationStats {
    wsRegistrationStats {
      newMemberRegistration
      completedRegistration
      registeredVisited
    }
  }
`;

export const WS_REDEMPTION_STATS = `
  query WsRedemptionStats {
    wsRedemptionStats {
      memberCheckedRewards
      sentRewardCode
      redeemedReward
    }
  }
`;

export const AVAILABLE_PROMOTIONS = `
  query AvailablePromotions(
      $limit: Int!,
      $sort: String,
      $direction: String
      $filters: PromotionSearch
    ) {
    slBrand {
      id
      promotions(
        limit: $limit,
        sort: $sort,
        direction: $direction,
        filters: $filters
      ) {
        id
        title
        promotionType
        cost
      }
    }
  }
`;

export const UPDATE_WS_REWARD_BUTTONS = `
  mutation UpdateWsRewardButtons(
    $promotionIds: [ID!]!,
    $fbWsTemplateId: ID!
  ) {
    updateWsRewardButtons(
      promotionIds: $promotionIds, 
      fbWsTemplateId: $fbWsTemplateId
    ) {
      result
      errors {
        message
      }
    }
  }
`;

export const GENERATE_UNLINK_WHATSAPP_AUTOMATION_CODE = `
  mutation GenerateUnlinkWhatsappAutomationCode {
    generateUnlinkWhatsappAutomationCode {
      result
      errors {
        message
      }
    }
  }
`;

export const UPDATE_WHATSAPP_CHAT_AUTOMATION_TRIGGER_PHRASE = `
  mutation UpdateWhatsappChatAutomationTriggerPhrase($triggerPhrase: String!) {
    updateWhatsappChatAutomationTriggerPhrase(triggerPhrase: $triggerPhrase) {
      result
      errors {
        message
      }
    }
  }
`;
